import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import * as moment from 'moment';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import MediaQuery from 'react-responsive';
import { Dispatch, connect } from 'react-redux';
import { GridApi, ColumnApi, GridReadyEvent, CsvExportParams, ProcessCellForExportParams, ProcessHeaderForExportParams } from 'ag-grid-community';
import { IWatrRequest, IWatrReimbursement, IListItem, IBaseResponse, IWatrRequestCounts, IWageAndTravelVerifyValidation, ICenterBase, IWageAndTravelRequestWeek, IPhysicianLetterWeekUpload, IWatrPaymentError, IWatrChaseImport, IPaystub, ApprovalEmailContract, IClaimDeclineResponseItem } from '@nkr/models/index';
import { IApplicationState, AppActionCreators, IAppState, WatrActionCreators, FileActionCreators, ActionCenterActionCreators, IWatrChaseExportListResponse, IReimbursementUpdateResponse, IWatrRequestUpdateResponse, IWatrAuditLogResponse, IReimbursementEntryResponse, IWatrRequestLookupDataResponse, IWatrRequestResponse, IWatrDetailsDataResponse, IWatrRequestCountsResponse, IWatrReimbursementResponse, IWatrLogsResponse, IWatrUpdateDonorRequest, IWatrChaseUploadResponse, IWatrConfirmReimbursementItem, IConfirmReimbursementsResponse } from '@nkr/store/index';
import { DsArea, WageAndTravelStatus, WageAndTravelCategory, WageAndTravelGroup, WageAndTravelViewType, ReimbursementType, WageAndTravelType, FileDocumentType, ApprovalEmailType, EmploymentType, OrganType, WageAndTravelReimbursementRequestStatus, DashDonationType, AdvancedWorkflowStatus } from '@nkr/enums/index';
import { isSelfEmployed, normalizeEmploymentType } from './utils/employment-type.utils';
import {
    getVerifyTaxErrorMessage,
    getVerifyTaxLoadingMessage,
    getVerifyTaxSuccessMessage
} from './utils/verify-tax-step-label';
import { getViewTypeByStatus, getUpdatedList, getTotalWagesReimbursedDays } from './helpers';
import { seedMileageRates } from './year-rates';
import { downloadFile } from '@nkr/services/download-file';
import { IDonorShieldContext, DonorShieldProvider } from './context';
import { IWatrViewerDocument } from '../utils/watr-viewer-document';
import Filters from './filters';
import DonorShieldReimbursementPolicies from './donor-shield-reimbursement-policies';
import Decline from './modals/decline';
import YearEndReport from './year-end-report';
import Transactions from './transactions';
import CancelRequest from './modals/cancel-request';

export type AdvancedWorkflowActionType = 'approve' | 'deny' | 'hold' | 'release' | 'activate';
import Sidebar from './sidebar';
import AdditionalInfoSidebar from './additional-info-sidebar';
import SearchBar from './searchbar';
import AdvancedFindBar, { AdvancedFindFields, AdvancedFindChip } from './advanced-find-bar';
import SubFilterBar from './subfilterbar';
import WatrAgGrid from './watr-ag-grid';
import ConfirmDonation from './modals/confirm-donation';
import RequestAdditional from './request-additional';
import AddRequest from './add-request';
import PendingRegistrationList from './pending-registration-list';
import OutstandingReimbursementRequests from '@nkr/views/center-admin/action-center/to-do/lists/outstanding-reimbursement-requests';
import PaymentError from './modals/payment-error';
import ChaseTransactionUpload from './modals/chase-transaction-upload';
import ValidateBankInfo from './modals/validate-bank-info';
import ApprovalEmail from './modals/approval-email';
import { IDeclineSelectionPayload } from './banking-decline-flags';
import { isAdvancedDsArea } from './watr-nav-area';
import {
    AdvancedRollupFilterValue,
    getAdvancedRollupFilterPillOrder,
    resolveAdvancedRollupBucket,
    advancedRollupTabLabel,
    AR_TAB_QUERY_KEY,
    tryParseArTabQueryValue,
    arTabQueryValueForFilter,
    readAdvancedProgressForBuckets,
    readIsInternationallyEligibleForWatr,
} from './advanced-reimbursement-status-buckets';
import { WatrListShell, WatrNavItemWrapper, WatrNavWrapper } from '../styles';

const EMPTY_ADVANCED_FIND: AdvancedFindFields = {
    name: '',
    alias: '',
    email: '',
    center: 0,
    organType: -1,
    intlDonor: -1,
    donationDateFrom: '',
    donationDateTo: '',
    birthDate: '',
};

const ADVANCED_AREA_SECTION = 'ADVANCED-REIMBURSEMENT';

const tabMap = [
    { id: WageAndTravelCategory.ToDo, section: '' },
    { id: WageAndTravelCategory.PendRegistration, section: 'PEND-REGISTRATION' },
    { id: WageAndTravelCategory.PendDocs, section: 'PEND-DOC' },
    { id: WageAndTravelCategory.PendVerify, section: 'PEND-VERIFY' },
    { id: WageAndTravelCategory.PendSurgery, section: 'PEND-SURGERY' },
    { id: WageAndTravelCategory.PendWageReimburse, section: 'PEND-WAGE' },
    { id: WageAndTravelCategory.PendTravelReceipts, section: 'PEND-RECEIPTS' },
    { id: WageAndTravelCategory.PendTravelReimbursement, section: 'PEND-TRAVEL' },
    { id: WageAndTravelCategory.Reimbursed, section: 'REIMBURSED' },
    { id: WageAndTravelCategory.NotReimbursed, section: 'NOT-REIMBURSED' },
    { id: WageAndTravelCategory.Search, section: 'SEARCH' },
    { id: WageAndTravelCategory.YearEndReport, section: 'YEAR-END' },
    { id: WageAndTravelCategory.Transactions, section: 'TRANSACTIONS' },
    { id: WageAndTravelCategory.AddRequest, section: 'ADD-REQUEST' },
    { id: WageAndTravelCategory.AddRequest, section: 'EDIT-REQUEST' },
    { id: WageAndTravelCategory.Donated, section: 'DONATED' },
    { id: WageAndTravelCategory.PendingWageToDo, section: 'PEND-WAGE-TO-DO' },
    { id: WageAndTravelCategory.PendingTravelToDo, section: 'PEND-TRAVEL-TO-DO' },
    { id: WageAndTravelCategory.PendingPayment, section: 'PEND-PAYMENT' },
    { id: WageAndTravelCategory.PendingWire, section: 'PEND-WIRE' },
    { id: WageAndTravelCategory.PaymentError, section: 'PAYMENT-ERROR' },
    { id: WageAndTravelCategory.PendingLWRVerify, section: 'PEND-LWR-VERIFY' },
    { id: WageAndTravelCategory.PendingDERVerify, section: 'PEND-DER-VERIFY' },
    { id: WageAndTravelCategory.PendingWire, section: 'PEND-WIRE' },
    { id: WageAndTravelCategory.PaymentError, section: 'PAYMENT-ERROR' }
];

function getAreaFromSection(section: string | undefined): DsArea {
    return section === ADVANCED_AREA_SECTION ? DsArea.Advanced : DsArea.Standard;
}

function readArTabFromLocationSearch(search: string): AdvancedRollupFilterValue | null {
    const parsed = qs.parse(search.length > 0 ? search : '', { arrayFormat: 'bracket' });
    const raw = parsed[AR_TAB_QUERY_KEY];
    return tryParseArTabQueryValue(raw as string | string[] | undefined);
}

function getDefaultAdvancedRollupFilterForCenterRoute(centerId: number, section: string | undefined): AdvancedRollupFilterValue {
    const fromUrl = typeof window !== 'undefined' ? readArTabFromLocationSearch(window.location.search) : null;
    if (fromUrl != null && section === ADVANCED_AREA_SECTION) {
        return fromUrl;
    }
    if (centerId <= 0) {
        return 'TODO_NKR';
    }
    if (section == null || section === '') {
        return 'ALL';
    }
    if (section === ADVANCED_AREA_SECTION) {
        return 'PENDING_DONOR';
    }
    return 'ALL';
}

type WatrSearchLoadFields = {
    firstName: string,
    lastName: string,
    email: string,
    birthDate: string,
    alias: string,
    center: number,
    startDate: string,
    endDate: string,
};

function shouldAutoRunWatrSearchOnLoad(
    category: WageAndTravelCategory,
    area: DsArea,
    advancedDeepSearchOpen: boolean,
    parsed: qs.ParsedQuery<string>,
    search: WatrSearchLoadFields,
    requestId: number,
): boolean {
    if (requestId > 0) {
        return true;
    }

    const hasTextCriteria =
        search.firstName !== ''
        || search.lastName !== ''
        || search.email !== ''
        || search.birthDate !== ''
        || search.alias !== '';

    const hasCenterFilter = search.center > 0;

    const hasUrlSearchParams =
        parsed.fn != null
        || parsed.ln != null
        || parsed.em != null
        || parsed.dob != null
        || parsed.alias != null
        || parsed.cid != null
        || parsed.sd != null
        || parsed.ed != null;

    const hasExplicitDateRange =
        (parsed.sd != null && search.startDate !== '')
        || (parsed.ed != null && search.endDate !== '');

    if (category === WageAndTravelCategory.Search) {
        return hasTextCriteria || hasCenterFilter || hasUrlSearchParams;
    }

    if (isAdvancedDsArea(area) && advancedDeepSearchOpen) {
        return hasTextCriteria || hasCenterFilter || hasUrlSearchParams;
    }

    return hasTextCriteria || hasCenterFilter || hasExplicitDateRange;
}

type WatrListViewState = {
    show: boolean,
    data: IWatrRequest,
    type: WageAndTravelViewType,
    reimbursements: IWatrReimbursement[],
    openReconcileReimbursementEntry: boolean
};

const EMPTY_WATR_VIEW: WatrListViewState = {
    show: false,
    data: null,
    type: WageAndTravelViewType.RequestData,
    reimbursements: [],
    openReconcileReimbursementEntry: false
};

function buildWatrViewState(partial: Partial<WatrListViewState>): WatrListViewState {
    return { ...EMPTY_WATR_VIEW, ...partial };
}

function patchWatrViewState(current: WatrListViewState, partial: Partial<WatrListViewState>): WatrListViewState {
    return { ...current, ...partial };
}

interface IProps {
    centerId: number,
    isSuperUser: boolean,
    section: string,
}

interface IStateProps {
    app: IAppState
}

interface Filter {
    id: number
}

interface TravelVerificationParams {
    travelRequestId: number;
    roundTripMiles: number;
    hotelLodgingExpense: number;
    flightAndTrainExpense: number;
    carServiceExpense: number;
    dependentCareExpense: number;
    mealExpense: number;
    isMilesOverWritten: boolean;
    overrideMiles: number;
    isMealsOverWritten: boolean;
    overrideMeals: number;
    isCarServiceExpenseOverridden: boolean;
    overrideCarServiceExpense: number;
    isDependentCareExpenseOverridden: boolean;
    overrideDependentCareExpense: number;
    isHotelLodgingExpenseOverridden: boolean;
    overrideHotelLodgingExpense: number;
}

interface VerifyStubParams {
    paystubs?: IPaystub[];
    requestId: number;
    startDate: string;
    endDate: string;
    amount: number;
    ssnDecrypted?: string;
    incomeIrsYear?: number;
    incomeIrsYearGross?: number;
}

interface VerifyTaxParams {
    requestId: number;
    ssnDecrypted: string;
    incomeIrsYear: number;
    incomeIrsYearGross: number;
}

interface VerifyAmountParams {
    requestId: number,
    amount: number,
    status: WageAndTravelStatus,
    sendEmail: boolean
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getRequestList: (centerId: number, area: DsArea, category: WageAndTravelCategory, startDate: string, endDate: string, isSuperUser: boolean, organType: OrganType) => Promise<IWatrRequestResponse>,
    searchRequests: (centerId: number, firstName: string, lastName: string, email: string, birthDate: string, alias: string, startDate: string, endDate: string, area: DsArea, category: number, isAdmin: boolean, organType: OrganType) => Promise<IWatrRequestResponse>,
    getRequestCounts: (centerId: number, area: DsArea, category: WageAndTravelCategory, startDate: string, endDate: string, isAdmin: boolean, organType: OrganType) => Promise<IWatrRequestCountsResponse>,
    downloadFile: (docType: number, lookupId: number) => Promise<any>,
    getTravelDetails: (centerId: number, requestId: number, isAdmin: boolean) => Promise<IWatrDetailsDataResponse>,
    getReimbursementsByRequestId: (requestId: number) => Promise<IWatrReimbursementResponse>,
    getRequestById: (centerId: number, requestId: number) => Promise<IWatrRequestResponse>,
    getLogsByRequestId: (requestId: number) => Promise<IWatrLogsResponse>,
    getRequestLookupData: (centerId: number, isSuperUser: boolean) => Promise<IWatrRequestLookupDataResponse>,
    updateDonorRequest: (request: IWatrUpdateDonorRequest) => Promise<IWatrRequestUpdateResponse>
    saveReimbursementEntry: (requestId: number, type: number, amount: number, confirmationCode: string, date: string, closeAdvancedReimbursementCard?: boolean) => Promise<IReimbursementEntryResponse>,
    confirmReimbursements: (items: IWatrConfirmReimbursementItem[]) => Promise<IConfirmReimbursementsResponse>,
    updateReimbursement: (requestId: number, reimbursementId: number, type: number, amount: number, confirmationCode: string, date: string) => Promise<IReimbursementUpdateResponse>,
    saveLogEntry: (requestId: number, type: number, comments: string, file: File) => Promise<IWatrAuditLogResponse>,
    updateLogEntry: (requestId: number, logId: number, type: number, comments: string, file: File) => Promise<IWatrAuditLogResponse>,
    deleteLogEntry: (requestId: number, logId: number) => Promise<IWatrAuditLogResponse>,
    verifyAmount: (requestId: number, status: WageAndTravelStatus, sendEmail: boolean, amount: number, approvalEmail: ApprovalEmailContract) => Promise<IWatrRequestUpdateResponse>,
    verifyStub: (requestId: number, startDate: string, endDate: string, amount: number, paystubs: any[], approvalEmail: ApprovalEmailContract, ssnDecrypted?: string, incomeIrsYear?: number, incomeIrsYearGross?: number) => Promise<IWatrRequestUpdateResponse>,
    setPaystubReviewRequired: (paystubId: number, reviewRequired: boolean) => Promise<IBaseResponse>,
    verifyTax: (requestId: number, ssnEncrypted: string, incomeIrsYear: number, incomeIrsYearGross, approvalEmail: ApprovalEmailContract) => Promise<IWatrRequestUpdateResponse>,
    verifyTravel: (travelRequestId: number, roundTripMiles: number, hotelLodgingExpense: number, flightAndTrainExpense: number, carServiceExpense: number, dependentCareExpense: number,
        mealExpense: number, isMilesOverWritten: boolean, overrideMiles: number, isMealsOverWritten: boolean, overrideMeals: number,
        isCarServiceExpenseOverridden: boolean, overrideCarServiceExpense: number,
        isDependentCareExpenseOverridden: boolean, overrideDependentCareExpense: number,
        isHotelLodgingExpenseOverridden: boolean, overrideHotelLodgingExpense: number,
        approvalEmail: ApprovalEmailContract
    ) => Promise<IWatrRequestUpdateResponse>,
    requestAdditionalDays: (requestId: number, additionalDays: number, additionalDaysSignOff, drFullNameSignOff) => Promise<IBaseResponse>,
    declineRequest: (requestId: number, emailSubject: string, firstParagraph: string, emailContent: string, lastParagraph: string, isTravel: boolean, isFixable: boolean, bccCenter: boolean, wageRepairRequested?: boolean, bankingRoutingRequiresReview?: boolean, bankingAccountRequiresReview?: boolean, declineReasonSummary?: string) => Promise<IBaseResponse>,
    cancelRequest: (requestId: number) => Promise<IBaseResponse>,
    confirmDonation: (requestId: number, signOffInitials: string) => Promise<IBaseResponse>,
    updateDonationDate: (requestId: number, donationDate: string) => Promise<IBaseResponse>,
    resendInvitation: (requestId: number) => Promise<IBaseResponse>,
    approveAdvancedReimbursement: (requestId: number, reason: string) => Promise<IBaseResponse>,
    denyAdvancedReimbursement: (requestId: number, reason: string) => Promise<IBaseResponse>,
    holdAdvancedReimbursement: (requestId: number, reason: string) => Promise<IBaseResponse>,
    releaseAdvancedReimbursement: (requestId: number, reason: string) => Promise<IBaseResponse>,
    activateAdvancedReimbursement: (requestId: number, reason: string) => Promise<IBaseResponse>,
    updateAudit: (requestId: number, type: WageAndTravelType, status: WageAndTravelStatus, reimbursementAmount: number, donationDate: string, incomePercentCovered: number, sixtyDayOverride: boolean, ninetyDayLWROverride: boolean, expenseLimitOverride: boolean) => Promise<IWatrRequestUpdateResponse>,
    updateWeekReimbursementRequestStatus: (centerId: number, list: IWageAndTravelRequestWeek[], physicianLetters?: IPhysicianLetterWeekUpload[]) => Promise<IBaseResponse>,
    updateWeekOtherAmount: (requestId: number, weekRequested: number, otherAmount: number, confirmedByInitials?: string) => Promise<IBaseResponse>,
    getChaseListExport: (organType: OrganType) => Promise<IWatrChaseExportListResponse>,
    updatePaymentError: (paymentError: IWatrPaymentError) => Promise<IBaseResponse>,
    getAchPayments: (organType: OrganType) => Promise<IBaseResponse>,
    validateAchRouting: () => Promise<IBaseResponse>,
    uploadChaseTransactions: (file: File) => Promise<IWatrChaseUploadResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    list: IWatrRequest[],
    counts: IWatrRequestCounts,
    donationTypes: IListItem[],
    requestTypes: IListItem[],
    statusTypes: IListItem[],
    auditLogTypes: IListItem[],
    logActionTypes: IListItem[],
    reimbursementTypes: IListItem[],
    additionalWeeksReasonList: IListItem[],
    claimDeclineResponseList: IClaimDeclineResponseItem[],
    centerList: ICenterBase[],
    categoryList: IListItem[],
    countryList: IListItem[],
    statusFilter: any[],
    organTypes: OrganType[],
    fetching: boolean,
    area: DsArea,
    category: WageAndTravelCategory,
    subCategory: WageAndTravelCategory,
    subGroup: WageAndTravelGroup[],
    filters: Filter,
    search: {
        firstName: string,
        lastName: string,
        email: string,
        birthDate: string,
        alias: string,
        center: number,
        area: DsArea,
        category: number,
        startDate: string,
        endDate: string
    },
    view: WatrListViewState,
    additionalInfoSidebar: {
        show: boolean,
        data: IWatrRequest,
        fileUrl: string,
        displayType: FileDocumentType,
        fileIds?: number[],
        currentIndex?: number,
        totalFiles?: number,
        fileIdToLineItemsMap?: Map<number, any[]>,
        onApproveLineItems?: (lineItemIds: number[]) => Promise<void>,
        onRequestReviewLineItems?: (lineItemIds: number[]) => Promise<void>,
        onExpenseTypeChange?: (expenseType: number | null) => void,
        onExpenseTypeApproved?: (expenseType: number) => void,
        onRefreshLineItems?: () => Promise<void>,
        onReviewRequiredStateChange?: (lineItemIds: number[], reviewRequired: boolean) => void,
        viewerDocs?: IWatrViewerDocument[],
        onViewerDocChange?: (docType: number, index: number) => void
    },
    modal: {
        show: boolean,
        data: any,
        type: WageAndTravelViewType,
    },
    viewmodal: {
        show: boolean,
        data: any,
    },
    travelId: number,
    isTravel: boolean,
    validation: IWageAndTravelVerifyValidation,
    isDirty: boolean,
    isValid: boolean,
    declineType: string,
    approvalEmailType: ApprovalEmailType,
    approvalData: any,
    hasLineItemsSelected?: boolean,
    organType: OrganType | null,
    restoreSidebarAfterDeclineClose: boolean,
    advancedStatusFilter: AdvancedRollupFilterValue,
    advancedFind: AdvancedFindFields,
    advancedDeepSearchOpen: boolean,
    advancedDeepSearchActive: boolean,
    advancedDeepSearchResults: IWatrRequest[],
    advancedStatusBeforeDeepSearch: AdvancedRollupFilterValue,
    advancedSourceList: IWatrRequest[],
}

class WageAndTravel extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        counts: null,
        donationTypes: [],
        requestTypes: [],
        statusTypes: [],
        auditLogTypes: [],
        logActionTypes: [],
        reimbursementTypes: [],
        additionalWeeksReasonList: [],
        claimDeclineResponseList: [],
        centerList: [],
        categoryList: [],
        countryList: [],
        statusFilter: [],
        organTypes: [OrganType.Kidney, OrganType.Liver],
        fetching: false,
        area: DsArea.Standard,
        category: WageAndTravelCategory.ToDo,
        subCategory: WageAndTravelCategory.PendVerify,
        subGroup: [1, 2],
        search: {
            firstName: '',
            lastName: '',
            email: '',
            birthDate: '',
            alias: '',
            center: 0,
            area: DsArea.Standard,
            category: 0,
            startDate: moment().subtract(60, 'days').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD')
        },
        view: { ...EMPTY_WATR_VIEW },
        additionalInfoSidebar: {
            show: false,
            data: null,
            displayType: null,
            fileUrl: '',
            fileIds: [],
            currentIndex: 0,
            totalFiles: 0,
            fileIdToLineItemsMap: new Map(),
            onApproveLineItems: undefined,
            onRequestReviewLineItems: undefined,
            onExpenseTypeChange: undefined,
            onExpenseTypeApproved: undefined,
            onRefreshLineItems: undefined,
            onReviewRequiredStateChange: undefined,
            viewerDocs: [],
            onViewerDocChange: undefined
        },
        modal: {
            show: false,
            data: null,
            type: null
        },
        viewmodal: {
            show: false,
            data: null
        },
        travelId: 0,
        isTravel: false,
        filters: {
            id: 0
        },
        validation: {
            ssnDecrypted: true,
            incomeIrsYear: true,
            incomeIrsYearGross: true,
            startDate: true,
            endDate: true,
            incomeGross: true
        },
        isDirty: false,
        isValid: true,
        declineType: 'Lost Wage',
        approvalEmailType: ApprovalEmailType.VerifyTax,
        approvalData: null,
        organType: null,
        restoreSidebarAfterDeclineClose: false,
        advancedStatusFilter: 'ALL',
        advancedFind: { ...EMPTY_ADVANCED_FIND },
        advancedDeepSearchOpen: false,
        advancedDeepSearchActive: false,
        advancedDeepSearchResults: [],
        advancedStatusBeforeDeepSearch: 'ALL',
        advancedSourceList: [],
    }

    gridApi: GridApi = null;
    columnApi: ColumnApi;

    gridApiTransactions: GridApi = null;
    columnApiTransactions: ColumnApi;

    gridApiYearEnd: GridApi = null;
    columnApiYearEnd: ColumnApi;

    gridApiPendingRegistration: GridApi = null;

    container: HTMLDivElement;
    intervalId: any;

    _isMounted = false;
    _dataFetchSeq = 0;
    _loadingOwnerSeq = 0;
    _tabChangeTimer: any = null;
    _pendingSoftCategory: WageAndTravelCategory = null;
    _pendingSoftArea: DsArea = DsArea.Standard;
    _pendingAdvancedFilter: AdvancedRollupFilterValue = null;

    componentDidMount = () => {
        this._isMounted = true;
        window.addEventListener('popstate', this.handleWatrPopState);
        let isCenterView = this.props.centerId > 0 ? true : false;

        let category = !isCenterView ? WageAndTravelCategory.PendingLWRVerify : WageAndTravelCategory.ToDo;

        let c = tabMap.find(x => x.section == this.props.section);

        if (c != null) {
            category = c.id;
        }

        let area = getAreaFromSection(this.props.section);

        let advFilter = getDefaultAdvancedRollupFilterForCenterRoute(this.props.centerId, this.props.section);
        let deepOpen = advFilter === 'SEARCH';
        if (deepOpen) {
            advFilter = 'ALL';
        }
        this.setState({
            category,
            area,
            advancedStatusFilter: advFilter,
            advancedDeepSearchOpen: deepOpen,
            advancedStatusBeforeDeepSearch: advFilter,
        }, () => {
            this.getData(area, category, true);
        });
    }

    componentDidUpdate = (prevProps: TProps) => {
        if (prevProps.section === this.props.section && prevProps.centerId === this.props.centerId) {
            return;
        }
        let advFilter = getDefaultAdvancedRollupFilterForCenterRoute(this.props.centerId, this.props.section);
        let deepOpen = advFilter === 'SEARCH';
        if (deepOpen) {
            advFilter = 'ALL';
        }
        let isCenterView = this.props.centerId > 0 ? true : false;
        let category = !isCenterView ? WageAndTravelCategory.PendingLWRVerify : WageAndTravelCategory.ToDo;
        let c = tabMap.find(x => x.section == this.props.section);
        if (c != null) {
            category = c.id;
        }
        let area = getAreaFromSection(this.props.section);
        this.setState({
            category,
            area,
            advancedStatusFilter: advFilter,
            advancedDeepSearchOpen: deepOpen,
            advancedDeepSearchActive: false,
            advancedDeepSearchResults: [],
            advancedStatusBeforeDeepSearch: advFilter,
            advancedFind: { ...EMPTY_ADVANCED_FIND },
        }, () => {
            this.getData(area, category, true);
        });
    }

    componentWillUnmount = () => {
        this._isMounted = false;
        if (this._tabChangeTimer != null) {
            clearTimeout(this._tabChangeTimer);
            this._tabChangeTimer = null;
        }
        window.removeEventListener('popstate', this.handleWatrPopState);
    }

    getData = (area: DsArea, category: WageAndTravelCategory, message: boolean, tabSwitch: boolean = false) => {
        const fetchSeq = ++this._dataFetchSeq;
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI(''), { arrayFormat: 'bracket' });

        var firstName = parsed.fn != null ? parsed.fn : (tabSwitch ? '' : this.state.search.firstName);
        var lastName = parsed.ln != null ? parsed.ln : (tabSwitch ? '' : this.state.search.lastName);
        var email = parsed.em != null ? parsed.em : (tabSwitch ? '' : this.state.search.email);
        var birthDate = parsed.dob != null ? parsed.dob : (tabSwitch ? '' : this.state.search.birthDate);
        var alias = parsed.alias != null ? parsed.alias : (tabSwitch ? '' : this.state.search.alias);
        var center = parsed.cid != null ? parseInt(parsed.cid) : (tabSwitch ? 0 : this.state.search.center);
        var requestId = tabSwitch ? 0 : (parsed.id != null ? parseInt(parsed.id as string, 10) : 0);
        var viewTypeRaw = parsed.viewType != null ? parsed.viewType : null;
        var viewTypeParam = Array.isArray(viewTypeRaw) ? viewTypeRaw[0] : viewTypeRaw;
        var subCategory = category == WageAndTravelCategory.ToDo ? parsed.subcat != null ? parseInt(parsed.subcat) : WageAndTravelCategory.PendVerify : 0;
        var subGroup = category == WageAndTravelCategory.ToDo ? parsed.subgrp != null ? parseInt(parsed.subgrp) : [1, 2] : 0;
        var subGroupArray = subGroup == WageAndTravelGroup.LostWage ? [1] :
            subGroup == WageAndTravelGroup.DonorExpense ? [2] :
                subGroup == WageAndTravelGroup.Both ? [1, 2] : [1, 2];
        var startDate = parsed.sd != null ? parsed.sd : category == WageAndTravelCategory.PendDocs ? moment().subtract(60, 'days').format('YYYY-MM-DD') : '';
        var endDate = parsed.ed != null ? parsed.ed : category == WageAndTravelCategory.PendDocs ? moment().format('YYYY-MM-DD') : '';

        if (category == WageAndTravelCategory.PendSurgery && this.props.isSuperUser) {
            startDate = parsed.sd != null ? parsed.sd : moment().subtract(1, 'days').format('YYYY-MM-DD');
            endDate = parsed.ed != null ? parsed.ed : moment().addDays(30,).format('YYYY-MM-DD');
        }

        let countsStartDate = startDate;
        let countsEndDate = endDate;
        if (this.props.isSuperUser && area === DsArea.Standard) {
            countsStartDate = parsed.sd != null ? parsed.sd : moment().subtract(1, 'days').format('YYYY-MM-DD');
            countsEndDate = parsed.ed != null ? parsed.ed : moment().add(30, 'days').format('YYYY-MM-DD');
        }

        let search = {
            firstName,
            lastName,
            email,
            birthDate,
            alias,
            center,
            area,
            category,
            startDate,
            endDate
        };

        let reportChildOwnsLoading =
            category == WageAndTravelCategory.YearEndReport
            || category == WageAndTravelCategory.Transactions;

        let shouldGetList =
            category != WageAndTravelCategory.YearEndReport
            && category != WageAndTravelCategory.Transactions
            && category != WageAndTravelCategory.AddRequest
            && category != WageAndTravelCategory.Search
            && category != WageAndTravelCategory.PendRegistration;

        let useLoading = (message || tabSwitch) && !reportChildOwnsLoading;
        if (useLoading && this._isMounted && !this.state.fetching) {
            this.setState({ fetching: true });
        }

        let start = Promise.resolve(null);

        let organType = this.resolveFetchOrganType(category);

        const lookupPromise = this.resolveLookupDataPromise();

        start.then(() => {
            if (!this._isMounted || fetchSeq !== this._dataFetchSeq) {
                return;
            }

            if (shouldGetList) {
                Promise.all([
                    this.props.getRequestCounts(this.props.centerId, area, category, countsStartDate, countsEndDate, this.props.isSuperUser, organType),
                    this.props.getRequestList(this.props.centerId, area, category, search.startDate, search.endDate, this.props.isSuperUser, organType),
                    lookupPromise
                ])
                    .then(([countsResponse, listResponse, lookupDataResponse]) => {
                        if (!this._isMounted || fetchSeq !== this._dataFetchSeq) return;

                        if (countsResponse?.data?.success && listResponse?.data?.success && lookupDataResponse?.data?.success) {
                            let counts = countsResponse.data.results;
                            let list = listResponse.data.results;

                            let { donationTypes, requestTypes, statusTypes, reimbursementTypes, auditLogTypes, logActionTypes, additionalWeeksReasonList, claimDeclineResponseList, centerList, categoryList, mileageRates, countryList } = lookupDataResponse.data.results || {};
                            seedMileageRates(mileageRates || (lookupDataResponse.data.results as any)?.MileageRates);

                            if (category == WageAndTravelCategory.ToDo) {
                                list = _.orderBy((list), x => x.status, ['desc']);
                            }

                            const advancedListState = this.applyAdvancedListForArea(list, area);

                            this.setState((prev) => ({
                                ...prev,
                                list: advancedListState.list,
                                advancedSourceList: advancedListState.advancedSourceList,
                                counts,
                                donationTypes,
                                requestTypes,
                                statusTypes,
                                reimbursementTypes,
                                auditLogTypes,
                                logActionTypes: logActionTypes || [],
                                additionalWeeksReasonList,
                                claimDeclineResponseList,
                                centerList: centerList || prev.centerList || [],
                                categoryList: categoryList || prev.categoryList || [],
                                countryList: countryList || prev.countryList || [],
                                area,
                                category,
                                subCategory,
                                subGroup: subGroupArray,
                                search,
                                fetching: false,
                                organType,
                                view: tabSwitch ? { ...EMPTY_WATR_VIEW } : prev.view,
                                modal: tabSwitch ? { show: false, data: null, type: null } : prev.modal,
                                viewmodal: tabSwitch ? { show: false, data: null } : prev.viewmodal,
                                additionalInfoSidebar: tabSwitch
                                    ? {
                                        ...prev.additionalInfoSidebar,
                                        show: false,
                                        data: null,
                                    }
                                    : prev.additionalInfoSidebar,
                            }), () => {
                                this._pendingSoftCategory = null;
                                this._pendingAdvancedFilter = null;
                                if (this._isMounted && requestId > 0) {

                                    const openReconcile =
                                        new URLSearchParams(window.location.search).get('reconcile') === '1';
                                    this.getRequestData(
                                        requestId,
                                        this.resolveViewTypeFromQuery(viewTypeParam),
                                        openReconcile
                                    );
                                } else if (
                                    this._isMounted
                                    && isAdvancedDsArea(area)
                                    && this.state.advancedDeepSearchOpen
                                    && shouldAutoRunWatrSearchOnLoad(
                                        category,
                                        area,
                                        this.state.advancedDeepSearchOpen,
                                        parsed,
                                        search,
                                        requestId)
                                ) {
                                    this.handleAdvancedDeepSearch();
                                }
                            });
                        } else if (tabSwitch && this._isMounted && fetchSeq === this._dataFetchSeq) {
                            this.setState({
                                category,
                                area,
                                list: [],
                                fetching: false,
                                view: { ...EMPTY_WATR_VIEW },
                                modal: { show: false, data: null, type: null },
                                viewmodal: { show: false, data: null },
                            }, () => {
                                this._pendingSoftCategory = null;
                            });
                        }
                    })
                    .finally(() => {
                        if (this._isMounted && fetchSeq === this._dataFetchSeq) {
                            this.setState({ fetching: false }, () => {
                                if (this.gridApi) {
                                    this.gridApi.hideOverlay();
                                }
                            });
                        }
                    });
            } else {
                Promise.all([
                    this.props.getRequestCounts(this.props.centerId, area, category, countsStartDate, countsEndDate, this.props.isSuperUser, organType),
                    lookupPromise
                ])
                    .then(async ([countsResponse, lookupDataResponse]) => {
                        if (!this._isMounted || fetchSeq !== this._dataFetchSeq) return;

                        if (countsResponse?.data?.success && lookupDataResponse?.data?.success) {
                            let counts = countsResponse.data.results;

                            let { donationTypes, requestTypes, statusTypes, reimbursementTypes, auditLogTypes, logActionTypes, centerList, categoryList, mileageRates, countryList } = lookupDataResponse.data.results || {};
                            seedMileageRates(mileageRates || (lookupDataResponse.data.results as any)?.MileageRates);

                            let list = [];

                            if (shouldAutoRunWatrSearchOnLoad(
                                category,
                                area,
                                this.state.advancedDeepSearchOpen,
                                parsed,
                                search,
                                requestId)) {
                                let centerId = this.props.centerId > 0 ? this.props.centerId : search.center;

                                let response = await this.props.searchRequests(
                                    centerId,
                                    search.firstName,
                                    search.lastName,
                                    search.email,
                                    search.birthDate,
                                    search.alias,
                                    search.startDate,
                                    search.endDate,
                                    area,
                                    search.category,
                                    this.props.isSuperUser,
                                    organType
                                );

                                if (this._isMounted && fetchSeq === this._dataFetchSeq && response?.data?.success) {
                                    list = response.data.results || [];
                                }
                            }

                            if (!this._isMounted || fetchSeq !== this._dataFetchSeq) return;

                            const advancedListState = this.applyAdvancedListForArea(list, area);

                            this.setState((prev) => ({
                                ...prev,
                                list: advancedListState.list,
                                advancedSourceList: advancedListState.advancedSourceList,
                                counts,
                                donationTypes,
                                requestTypes,
                                statusTypes,
                                reimbursementTypes,
                                auditLogTypes,
                                logActionTypes: logActionTypes || [],
                                centerList,
                                categoryList,
                                countryList: countryList || prev.countryList || [],
                                area,
                                category,
                                search,
                                fetching: false,
                                organType,
                                view: tabSwitch ? { ...EMPTY_WATR_VIEW } : prev.view,
                                modal: tabSwitch ? { show: false, data: null, type: null } : prev.modal,
                                viewmodal: tabSwitch ? { show: false, data: null } : prev.viewmodal,
                                additionalInfoSidebar: tabSwitch
                                    ? {
                                        ...prev.additionalInfoSidebar,
                                        show: false,
                                        data: null,
                                    }
                                    : prev.additionalInfoSidebar,
                            }), () => {
                                this._pendingSoftCategory = null;
                                this._pendingAdvancedFilter = null;
                                if (this.gridApi) {
                                    this.gridApi.hideOverlay();
                                }
                                if (this._isMounted && requestId > 0) {
                                    const openReconcile =
                                        new URLSearchParams(window.location.search).get('reconcile') === '1';
                                    this.getRequestData(
                                        requestId,
                                        this.resolveViewTypeFromQuery(viewTypeParam),
                                        openReconcile
                                    );
                                }
                            });
                        } else if (tabSwitch && this._isMounted && fetchSeq === this._dataFetchSeq) {
                            this.setState({
                                category,
                                area,
                                list: [],
                                fetching: false,
                                view: { ...EMPTY_WATR_VIEW },
                                modal: { show: false, data: null, type: null },
                                viewmodal: { show: false, data: null },
                            }, () => {
                                this._pendingSoftCategory = null;
                                if (this.gridApi) {
                                    this.gridApi.hideOverlay();
                                }
                            });
                        }
                    })
                    .finally(() => {
                        if (this._isMounted && fetchSeq === this._dataFetchSeq) {
                            this.setState({ fetching: false }, () => {
                                if (this.gridApi) {
                                    this.gridApi.hideOverlay();
                                }
                            });
                        }
                    });
            }
        });
    }

    resolveLookupDataPromise = () => {
        if (this.state.donationTypes?.length > 0 && this.state.categoryList?.length > 0) {
            return Promise.resolve({
                data: {
                    success: true,
                    results: {
                        donationTypes: this.state.donationTypes,
                        requestTypes: this.state.requestTypes,
                        statusTypes: this.state.statusTypes,
                        reimbursementTypes: this.state.reimbursementTypes,
                        auditLogTypes: this.state.auditLogTypes,
                        logActionTypes: this.state.logActionTypes,
                        additionalWeeksReasonList: this.state.additionalWeeksReasonList,
                        claimDeclineResponseList: this.state.claimDeclineResponseList,
                        centerList: this.state.centerList,
                        categoryList: this.state.categoryList,
                    }
                }
            } as any);
        }
        return this.props.getRequestLookupData(this.props.centerId, this.props.isSuperUser);
    }

    buildStandardCategoryPath = (category: WageAndTravelCategory): string => {
        const currentTab = tabMap.find(x => x.id == category);
        const sectionPath = currentTab != null ? currentTab.section.toLowerCase() : '';
        return this.props.isSuperUser
            ? '/admin/dash/watr/' + sectionPath
            : '/center/' + this.props.centerId + '/donors/watr/' + sectionPath;
    }

    resolveCategoryFromPathname = (pathname: string): { area: DsArea, category: WageAndTravelCategory } => {
        const path = (pathname || '').toLowerCase();
        if (path.indexOf('advanced-reimbursement') >= 0) {
            return { area: DsArea.Advanced, category: WageAndTravelCategory.Search };
        }

        let section = '';
        const marker = '/watr/';
        const idx = path.lastIndexOf(marker);
        if (idx >= 0) {
            section = path.substring(idx + marker.length).replace(/\/+$/, '');
        }

        let isCenterView = this.props.centerId > 0;
        let category = !isCenterView ? WageAndTravelCategory.PendingLWRVerify : WageAndTravelCategory.ToDo;
        if (section === '') {
            return { area: DsArea.Standard, category };
        }

        let c = tabMap.find(x => x.section.toLowerCase() === section);
        if (c != null) {
            category = c.id;
        }

        let area = getAreaFromSection(section.toUpperCase());
        if (section === 'year-end' || section === 'transactions') {
            area = DsArea.Standard;
        }
        return { area, category };
    }

    applyAdvancedListForArea = (rawList: IWatrRequest[], area: DsArea): { list: IWatrRequest[], advancedSourceList: IWatrRequest[] } => {
        if (!isAdvancedDsArea(area)) {
            return { list: rawList, advancedSourceList: [] };
        }

        const filter = this._pendingAdvancedFilter != null
            ? this._pendingAdvancedFilter
            : this.state.advancedStatusFilter;
        let list = rawList;
        if (filter
            && filter !== 'ALL'
            && filter !== 'SEARCH'
            && !this.state.advancedDeepSearchActive) {
            list = rawList.filter(x => resolveAdvancedRollupBucket(x) === filter);
        }

        return { list, advancedSourceList: rawList };
    }

    scheduleSoftAdvancedStatusLoad = (filter: AdvancedRollupFilterValue) => {
        if (filter === 'SEARCH') {
            this.handleToggleAdvancedDeepSearch(true);
            return;
        }

        this._pendingAdvancedFilter = filter;
        this._dataFetchSeq++;
        if (this._tabChangeTimer != null) {
            clearTimeout(this._tabChangeTimer);
            this._tabChangeTimer = null;
        }

        this.replaceArTabQueryInBrowserUrl(filter);
        const clearFind = filter === 'TODO_NKR';
        const afterSoftStart = () => {
            if (this.gridApi) {
                this.gridApi.hideOverlay();
            }
        };

        if (clearFind) {
            this.setState({
                fetching: true,
                list: [],
                advancedStatusFilter: filter,
                advancedStatusBeforeDeepSearch: filter,
                advancedDeepSearchActive: false,
                advancedDeepSearchOpen: false,
                advancedDeepSearchResults: [],
                advancedFind: { ...EMPTY_ADVANCED_FIND },
            }, afterSoftStart);
        } else {
            this.setState({
                fetching: true,
                list: [],
                advancedStatusFilter: filter,
                advancedStatusBeforeDeepSearch: filter,
                advancedDeepSearchActive: false,
                advancedDeepSearchOpen: false,
                advancedDeepSearchResults: [],
            }, afterSoftStart);
        }

        this._tabChangeTimer = setTimeout(() => {
            this._tabChangeTimer = null;
            if (!this._isMounted) {
                return;
            }
            this.getData(DsArea.Advanced, this.state.category, false, true);
        }, 200);
    }

    scheduleSoftCategoryLoad = (category: WageAndTravelCategory, area: DsArea, pushUrl: boolean) => {
        this._pendingSoftCategory = category;
        this._pendingSoftArea = area;
        this._pendingAdvancedFilter = null;
        this._dataFetchSeq++;
        if (this._tabChangeTimer != null) {
            clearTimeout(this._tabChangeTimer);
            this._tabChangeTimer = null;
        }

        if (pushUrl) {
            window.history.pushState({}, '', this.buildStandardCategoryPath(category));
        }

        this.setState({
            fetching: true,
            list: [],
            category,
            area,
            view: { ...EMPTY_WATR_VIEW },
            modal: { show: false, data: null, type: null },
            viewmodal: { show: false, data: null },
            additionalInfoSidebar: {
                ...this.state.additionalInfoSidebar,
                show: false,
                data: null,
            },
        }, () => {
            if (this.gridApi) {
                this.gridApi.hideOverlay();
            }
        });

        this._tabChangeTimer = setTimeout(() => {
            this._tabChangeTimer = null;
            if (!this._isMounted) return;
            const nextCategory = this._pendingSoftCategory;
            const nextArea = this._pendingSoftArea;
            if (nextCategory == null) {
                return;
            }
            this.getData(nextArea, nextCategory, false, true);
        }, 200);
    }

    handleWatrPopState = () => {
        if (!this._isMounted) return;
        const resolved = this.resolveCategoryFromPathname(window.location.pathname);
        if (isAdvancedDsArea(resolved.area) !== isAdvancedDsArea(this.state.area)) {
            window.location.reload();
            return;
        }
        this.scheduleSoftCategoryLoad(resolved.category, resolved.area, false);
    }

    handleStandardCategoryChange = (category: WageAndTravelCategory) => {
        const current = this._pendingSoftCategory != null ? this._pendingSoftCategory : this.state.category;
        if (category == current && !isAdvancedDsArea(this.state.area)) {
            return;
        }
        if (tabMap.find(x => x.id == category) == null) {
            return;
        }
        this.scheduleSoftCategoryLoad(category, DsArea.Standard, true);
    }

    handleReportTabChange = (category: WageAndTravelCategory) => {
        const current = this._pendingSoftCategory != null ? this._pendingSoftCategory : this.state.category;
        if (category == current) {
            return;
        }
        if (tabMap.find(x => x.id == category) == null) {
            return;
        }
        this.scheduleSoftCategoryLoad(category, DsArea.Standard, true);
    }

    refreshDataAfterUpdate = () => {
        if (isAdvancedDsArea(this.state.area) && this.state.advancedDeepSearchActive) {
            return;
        }
        let countsStartDate = this.state.search.startDate;
        let countsEndDate = this.state.search.endDate;
        if (this.props.isSuperUser && this.state.area === DsArea.Standard) {
            countsStartDate = this.state.search.startDate || moment().subtract(1, 'days').format('YYYY-MM-DD');
            countsEndDate = this.state.search.endDate || moment().add(30, 'days').format('YYYY-MM-DD');
        }
        const organType = this.resolveFetchOrganType(this.state.category);
        Promise.all([
            this.props.getRequestCounts(this.props.centerId, this.state.area, this.state.category, countsStartDate, countsEndDate, this.props.isSuperUser, organType),
            this.props.getRequestList(this.props.centerId, this.state.area, this.state.category, this.state.search.startDate, this.state.search.endDate, this.props.isSuperUser, organType),
        ])
            .then(([countResponse, requestListResponse]) => {
                if (!this._isMounted) return;
                if (countResponse?.data?.success && requestListResponse?.data?.success) {
                    this.setState({
                        list: requestListResponse.data.results,
                        counts: countResponse.data.results,
                        organType,
                    });
                }
            })
            .finally(() => {
                if (this._isMounted) this.props.hideLoading();
            });
    }

    getTotal = () => {
        if (this.state.counts != null) {
            let { toDoTotal, pendingDocumentsTotal, pendingPaymentTotal, pendingVerifyTotal, pendingSurgeryTotal, donated, reimbursedTotal, notReimbursedTotal } = this.state.counts;
            return toDoTotal + pendingDocumentsTotal + pendingPaymentTotal + pendingVerifyTotal + pendingSurgeryTotal + donated + reimbursedTotal + notReimbursedTotal;
        }

        return 0;
    }

    resolveFetchOrganType = (_category?: WageAndTravelCategory): OrganType | null => {
        let organTypes = this.state.organTypes;
        return organTypes.length == 2 ? null : organTypes[0];
    }

    /** Same path + query `getData` reads on load (`id`, `viewType`, filters). */
    buildWatrListUrlWithQuery = (): string => {
        let { firstName, lastName, email, birthDate, alias, center, startDate, endDate } = this.state.search;
        let { subCategory, subGroup } = this.state;

        var selectedGroup = subGroup.length == 0 ? WageAndTravelGroup.Niether :
            subGroup.includes(WageAndTravelGroup.LostWage) && subGroup.includes(WageAndTravelGroup.DonorExpense) ? WageAndTravelGroup.Both :
                subGroup.includes(WageAndTravelGroup.LostWage) ? WageAndTravelGroup.LostWage :
                    subGroup.includes(WageAndTravelGroup.DonorExpense) ? WageAndTravelGroup.DonorExpense : -1;

        let paramList = [];

        if (firstName != '') {
            paramList.push('fn=' + firstName);
        }

        if (lastName != '') {
            paramList.push('ln=' + lastName);
        }

        if (email != '') {
            paramList.push('em=' + email);
        }

        if (birthDate != '') {
            paramList.push('dob=' + birthDate);
        }

        if (alias != '') {
            paramList.push('alias=' + alias);
        }

        if (center > 0) {
            paramList.push(encodeURI('cid=' + center));
        }

        if (this.state.view.show && this.state.view.data != null) {
            paramList.push('id=' + this.state.view.data.id);
            let viewTypeQuery: string = null;
            switch (this.state.view.type) {
                case WageAndTravelViewType.RequestData:
                    viewTypeQuery = 'RequestData';
                    break;
                case WageAndTravelViewType.ReimburseTravel:
                    viewTypeQuery = 'ReimburseTravel';
                    break;
                case WageAndTravelViewType.ReimburseWage:
                    viewTypeQuery = 'ReimburseWage';
                    break;
                case WageAndTravelViewType.ReimburseWageAudit:
                    viewTypeQuery = 'ReimburseWageAudit';
                    break;
                case WageAndTravelViewType.VerifyTravel:
                    viewTypeQuery = 'VerifyTravel';
                    break;
                case WageAndTravelViewType.VerifyWage:
                    viewTypeQuery = 'VerifyWage';
                    break;
                case WageAndTravelViewType.VerifyStub:
                    viewTypeQuery = 'VerifyStub';
                    break;
                case WageAndTravelViewType.VerifyAmount:
                    viewTypeQuery = 'VerifyAmount';
                    break;
                default:
                    break;
            }
            if (viewTypeQuery != null) {
                paramList.push('viewType=' + encodeURIComponent(viewTypeQuery));
            }
        }

        if (subCategory != null) {
            paramList.push('subcat=' + subCategory);
        }

        if (selectedGroup != null) {
            paramList.push('subgrp=' + selectedGroup);
        }

        if (this.state.category != WageAndTravelCategory.ToDo) {
            if (startDate != '') {
                paramList.push(encodeURI('sd=' + startDate));
            }

            if (endDate != '') {
                paramList.push(encodeURI('ed=' + endDate));
            }
        }

        if (isAdvancedDsArea(this.state.area)) {
            if (this.state.advancedDeepSearchOpen || this.state.advancedDeepSearchActive) {
                paramList.push(`${AR_TAB_QUERY_KEY}=${encodeURIComponent(arTabQueryValueForFilter('SEARCH'))}`);
            } else if (this.state.advancedStatusFilter && this.state.advancedStatusFilter !== 'ALL') {
                paramList.push(`${AR_TAB_QUERY_KEY}=${encodeURIComponent(arTabQueryValueForFilter(this.state.advancedStatusFilter))}`);
            }
        }

        let params = paramList.join('&');

        let currentTab = tabMap.find(x => x.id == this.state.category);

        let currentUrl = this.props.isSuperUser ? '/admin/dash/watr/' + currentTab.section.toLowerCase() : '/center/' + this.props.centerId + '/donors/watr/' + currentTab.section.toLowerCase();

        if (isAdvancedDsArea(this.state.area)) {
            currentUrl = this.props.isSuperUser ? '/admin/dash/watr/advanced-reimbursement' : '/center/' + this.props.centerId + '/donors/watr/advanced-reimbursement';
        }

        return currentUrl + '?' + params;
    }

    setUrlParameters = () => {
        window.history.pushState({}, '', this.buildWatrListUrlWithQuery());
    }

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.columnApi = e.columnApi;
    }

    onTransactionsGridReady = (e: GridReadyEvent) => {
        this.gridApiTransactions = e.api;
        this.columnApiTransactions = e.columnApi;
    }

    onPendingRegistrationGridReady = (e: GridReadyEvent) => {
        this.gridApiPendingRegistration = e.api;
    }

    onYearEndGridReady = (e: GridReadyEvent) => {
        this.gridApiYearEnd = e.api;
        this.columnApiYearEnd = e.columnApi;
    }

    resolveViewTypeFromQuery = (viewTypeParam: string | null | undefined): WageAndTravelViewType => {
        if (!viewTypeParam) {
            return WageAndTravelViewType.RequestData;
        }
        const viewTypeMap: { [key: string]: WageAndTravelViewType } = {
            'ReimburseTravel': WageAndTravelViewType.ReimburseTravel,
            'ReimburseWage': WageAndTravelViewType.ReimburseWage,
            'ReimburseWageAudit': WageAndTravelViewType.ReimburseWageAudit,
            'RequestData': WageAndTravelViewType.RequestData,
            'VerifyTravel': WageAndTravelViewType.VerifyTravel,
            'VerifyWage': WageAndTravelViewType.VerifyWage,
            'VerifyStub': WageAndTravelViewType.VerifyStub,
            'VerifyAmount': WageAndTravelViewType.VerifyAmount
        };
        return viewTypeMap[viewTypeParam] || WageAndTravelViewType.RequestData;
    }

    getRequestData = (requestId: number, viewType: WageAndTravelViewType, openReconcileReimbursementEntry: boolean = false) => {
        let isTravel = (viewType == WageAndTravelViewType.RequestData || viewType == WageAndTravelViewType.ReimburseWageAudit) ? false : viewType == WageAndTravelViewType.ReimburseTravel;

        this.props.showLoading('Loading data...').then(() => {
            if (!this._isMounted) return;

            this.props.getTravelDetails(this.props.centerId, requestId, this.props.isSuperUser)
                .then(response => {
                    if (!this._isMounted) return;

                    const res = response?.data;

                    if (!res?.success || !res?.results) return;

                    const { watrBasicDetail, watrReimbursements, watrTravelLogs } = res.results;

                    if (!watrBasicDetail) return;

                    watrBasicDetail.logs = _.orderBy(watrTravelLogs || [], ['logDate'], 'desc');

                    const listRow = this.state.list.find(x => x.id === requestId);
                    const listProgress = listRow ? readAdvancedProgressForBuckets(listRow) : undefined;
                    const detailProgress = readAdvancedProgressForBuckets(watrBasicDetail);
                    if (listProgress
                        && (listProgress.networkRemoteStatus != null || listProgress.preOpScheduledDate)
                        && !(detailProgress?.networkRemoteStatus != null || detailProgress?.preOpScheduledDate)) {
                        watrBasicDetail.advancedProgress = {
                            ...(watrBasicDetail.advancedProgress || {}),
                            ...listProgress
                        };
                    }

                    this.setState({
                        view: buildWatrViewState({
                            type: viewType,
                            show: true,
                            data: watrBasicDetail,
                            reimbursements: watrReimbursements || [],
                            openReconcileReimbursementEntry
                        }),
                        travelId: 0,
                        isTravel
                    });
                })
                .finally(() => {
                    if (this._isMounted) {
                        this.props.hideLoading();
                    }
                });
        });
    }

    getRequestDataForAudit = (requestId: number) => {
        this.props.showLoading('Loading data...').then(() => {
            if (!this._isMounted) return;

            Promise.all([
                this.props.getRequestById(this.props.centerId, requestId),
                this.props.getTravelDetails(this.props.centerId, requestId, this.props.isSuperUser)
            ])
                .then(([reqResponse, detailsResponse]) => {
                    if (!this._isMounted) return;
                    if (reqResponse?.data?.success && detailsResponse?.data?.success) {
                        const results = detailsResponse.data.results;
                        const watrBasicDetail = results?.watrBasicDetail;
                        const reimbursements = results?.watrReimbursements;
                        const watrTravelLogs = results?.watrTravelLogs;
                        const reqResults = reqResponse.data.results;
                        if (!watrBasicDetail) return;
                        let data = watrBasicDetail;
                        data.logs = _.orderBy(watrTravelLogs || [], ['logDate'], 'desc');
                        if (reqResults && reqResults[0]) {
                            data.totalWagesReimbursedDays = getTotalWagesReimbursedDays(reqResults[0], reimbursements);
                        } else {
                            data.totalWagesReimbursedDays = getTotalWagesReimbursedDays(data, reimbursements);
                        }

                        if (!this._isMounted) return;
                        this.setState({
                            view: buildWatrViewState({
                                type: WageAndTravelViewType.ReimburseWageAudit,
                                show: true,
                                data,
                                reimbursements: reimbursements || []
                            }),
                            travelId: 0,
                            isTravel: false,
                        });
                    }
                })
                .finally(() => {
                    if (this._isMounted) this.props.hideLoading();
                });
        });
    }

    handleUpdateDonorRequest = (
        requestId: number, firstName: string, lastName: string, email: string, mobile: string, birthDate: string, expirationDate: string,
        achAccountNumber: string, achRoutingNumber: string, intlBankingNumber: string, intlSwiftNumber: string,
        nameOfBank: string, cityTownLocality: string, stateProvinceRegion: string, bankingPostalCode: string, additionalCode: string,
        bankCountry: number | null
    ) => {
        let { addressLine1, addressLine2, city, state, postalCode, country, countryOfCitizenship, isUsBank } = this.state.view.data;

        let request: IWatrUpdateDonorRequest = {
            requestId,
            firstName, middleInitial: '', lastName, email, mobile, birthDate, expirationDate,
            achAccountNumber, achRoutingNumber, intlBankingNumber, intlSwiftNumber,
            isUsBank, bankCountry,
            bankInformation: { nameOfBank, cityTownLocality, stateProvinceRegion, postalCode: bankingPostalCode, additionalCode },
            addressLine1, addressLine2, city, state, postalCode, country, countryOfCitizenship, isAdmin: this.props.isSuperUser
        };

        this.props.updateDonorRequest(request)
            .then(response => {
                if (response.data.success) {
                    let req = response.data.results;

                    const resolvedBankCountry = req.bankCountry ?? bankCountry;
                    const resolvedBankCountryName = req.bankCountryName
                        || (this.state.countryList || []).find(c => Number(c.id) === Number(resolvedBankCountry))?.description
                        || '';

                    let list = _.cloneDeep(this.state.list).map(item => {
                        if (item.id == req.id) {
                            item.firstName = req.firstName;
                            item.lastName = req.lastName;
                            item.email = req.email;
                            item.mobile = req.mobile;
                            item.birthDate = req.birthDate;
                            item.expirationDate = req.expirationDate;
                            item.achAccountNumber = req.achAccountNumber;
                            item.achRoutingNumber = req.achRoutingNumber;
                            item.bankCountry = resolvedBankCountry;
                            item.bankCountryName = resolvedBankCountryName;
                            item.name = `${req.firstName} ${req.lastName}`;
                        }
                        return item;
                    });

                    var viewData = _.cloneDeep(list.find(x => x.id == this.state.view.data.id));

                    this.setState({
                        list,
                        view: {
                            ...this.state.view,
                            data: {
                                ...viewData,
                                bankInformation: request.bankInformation,
                                bankCountry: resolvedBankCountry,
                                bankCountryName: resolvedBankCountryName
                            }
                        }
                    }, () => {
                        this.props.hideLoading();

                        toast.success('Request updated successfully');
                    });
                }
            })
            .catch((error: AxiosError) => {
                this.props.hideLoading();
            });
    }

    handleUpdateRequestBanking = (requestId: number, banking: { achAccountNumber: string, achRoutingNumber: string, intlBankingNumber: string, intlSwiftNumber: string, bankInformation: { nameOfBank: string, cityTownLocality: string, stateProvinceRegion: string, postalCode: string, additionalCode: string } }) => {
        const d = this.state.view?.data;

        if (!d) return Promise.resolve();

        this.props.showLoading('Saving banking...');

        const request: IWatrUpdateDonorRequest = {
            requestId,
            firstName: d.firstName,
            middleInitial: d.middleInitial ?? '',
            lastName: d.lastName,
            email: d.email,
            mobile: d.mobile ?? '',
            birthDate: d.birthdate ?? d.birthDate ?? '',
            expirationDate: d.expirationDate ?? '',
            achAccountNumber: banking.achAccountNumber,
            achRoutingNumber: banking.achRoutingNumber,
            intlBankingNumber: banking.intlBankingNumber,
            intlSwiftNumber: banking.intlSwiftNumber,
            bankInformation: banking.bankInformation,
            addressLine1: d.addressLine1 ?? '',
            addressLine2: d.addressLine2 ?? '',
            city: d.city ?? '',
            state: d.state ?? 0,
            postalCode: d.postalCode ?? '',
            country: d.country ?? 0,
            countryOfCitizenship: d.countryOfCitizenship ?? 0,
            isAdmin: this.props.isSuperUser
        };

        return this.props.updateDonorRequest(request)
            .then(response => {
                if (response.data.success) {
                    const req = response.data.results;

                    const list = _.cloneDeep(this.state.list).map(item => {
                        if (item.id === req.id) {
                            item.achAccountNumber = req.achAccountNumber;
                            item.achRoutingNumber = req.achRoutingNumber;
                        }

                        return item;
                    });

                    const viewData = _.cloneDeep(list.find(x => x.id === this.state.view.data.id));

                    this.setState({
                        list,
                        view: { ...this.state.view, data: { ...viewData, bankInformation: banking.bankInformation } }
                    }, () => {
                        toast.success('Banking information updated.');
                    });
                } else {
                    return Promise.reject(new Error(response.data.message || 'Update failed'));
                }
            })
            .catch((error: AxiosError) => {
                toast.error('Unable to update banking information.');
                return Promise.reject(error);
            })
            .finally(() => {
                this.props.hideLoading();
            })
    };

    handleDeclineRequest = (requestId: number, emailSubject: string, firstParagraph: string, emailContent: string, lastParagraph: string, isFixable: boolean, bccCenter: boolean, selection: IDeclineSelectionPayload) => {
        let useId = requestId;
        let isTravel = this.state.isTravel;

        if (isTravel) {
            useId = this.state.travelId;
        }

        const donorData = this.state.modal.data || this.state.view.data;
        const firstName = donorData ? donorData.firstName : '';
        const lastName = donorData ? donorData.lastName : '';

        this.props.showLoading('Loading data...').then(() => {
            this.props.declineRequest(useId, emailSubject, firstParagraph, emailContent, lastParagraph, isTravel, isFixable, bccCenter, selection.wageRepairRequested, selection.bankingRoutingRequiresReview, selection.bankingAccountRequiresReview, selection.declineReasonSummary)
                .then(response => {
                    if (response.data.success) {
                        const isPaymentErrorCategory = this.state.category === WageAndTravelCategory.PaymentError;
                        const toastMessage = isPaymentErrorCategory
                            ? `An email has been sent to ${firstName} ${lastName} requesting review and correction of their information.`
                            : `${firstName} ${lastName} pay stub has been declined.`;

                        const declineData = response.data as { success: boolean; warning?: string; Warning?: string };
                        const archiveWarning = declineData.warning || declineData.Warning;

                        if (archiveWarning) {
                            toast.warn(archiveWarning);
                        } else {
                            toast.success(toastMessage);
                        }

                        this.setState({
                            modal: {
                                show: false,
                                data: this.state.modal.data,
                                type: WageAndTravelViewType.DeclineRequest
                            },
                            restoreSidebarAfterDeclineClose: false,
                            view: buildWatrViewState({
                                show: false,
                                data: null,
                                reimbursements: []
                            }),
                            additionalInfoSidebar: {
                                show: false,
                                data: null,
                                displayType: 0,
                                fileUrl: '',
                                fileIds: [],
                                currentIndex: 0,
                                totalFiles: 0,
                                fileIdToLineItemsMap: new Map(),
                                onApproveLineItems: undefined,
                                onRequestReviewLineItems: undefined,
                                onExpenseTypeChange: undefined,
                                onExpenseTypeApproved: undefined,
                                onRefreshLineItems: undefined,
                                onReviewRequiredStateChange: undefined,
                                viewerDocs: [],
                                onViewerDocChange: undefined
                            },
                            travelId: 0,
                            isTravel: false
                        }, () => {
                            this.setUrlParameters();

                            if (this.state.category == WageAndTravelCategory.Search) {
                                this.handleSearch();
                            } else {
                                this.getData(this.state.area, this.state.category, true);
                            }
                        });
                    } else {
                        const errorMessage = response.data?.results || response.data?.message || 'An error occurred while declining the request.';
                        toast.error(errorMessage);
                    }
                })
                .catch((error: AxiosError) => {
                    const data: any = error?.response?.data;
                    const errorMessage = data?.results || data?.message || error?.message || 'An error occurred while declining the request.';
                    toast.error(typeof errorMessage === 'string' ? errorMessage : 'An error occurred while declining the request.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleCancelRequest = () => {
        this.props.showLoading('Loading data...').then(() => {
            this.props.cancelRequest(this.state.modal.data.id).then(async response => {
                this.props.hideLoading();

                if (response.data.success) {
                    this.setState({
                        view: patchWatrViewState(this.state.view, {
                            show: false,
                            reimbursements: []
                        }),
                        modal: {
                            show: false,
                            data: this.state.modal.data,
                            type: this.state.modal.type
                        }
                    }, () => {
                        this.props.hideLoading();
                        toast.success(`${this.state.modal.data.firstName} ${this.state.modal.data.lastName}'s request cancelled.`);
                        this.getData(this.state.area, this.state.category, true);
                    });
                }
            });
        }, () => {
            this.props.hideLoading();
        });
    }

    handlePaymentErrorUpdate = (paymentError: IWatrPaymentError) => {
        this.props.showLoading('Updating payment error data...').then(() => {
            this.props.updatePaymentError(paymentError)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            modal: {
                                data: this.state.modal.data,
                                show: false,
                                type: this.state.modal.type,
                            }
                        }, () => {
                            this.props.hideLoading();
                            toast.success('Payment error data updated.');
                            this.getData(this.state.area, this.state.category, true);
                        });
                    } else {
                        this.props.hideLoading();
                        toast.error('Unable to update payment error data: ' + response.data.message);
                    }
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                    toast.error('Unable to update payment error data.');
                });
        });
    }

    handleRequestAdditionalDays = (requestId: number, additionalDays: number, additionalDaysSignOff: string, drFullNameSignOff: string) => {
        this.props.showLoading('Loading data...').then(() => {
            this.props.requestAdditionalDays(requestId, additionalDays, additionalDaysSignOff, drFullNameSignOff).then(async response => {
                this.props.hideLoading();

                if (response.data.success) {
                    this.setState({
                        modal: {
                            show: false,
                            data: this.state.modal.data,
                            type: this.state.modal.type,
                        }
                    }, () => {
                        this.props.hideLoading();
                        toast.success('Additional Days for ' + this.state.modal.data.firstName + ' ' + this.state.modal.data.lastName + ' have been requested.');
                        this.getData(this.state.area, this.state.category, true);
                    });
                } else {
                    this.props.hideLoading();
                    toast.error('Unable to complete request: ' + response.data.message);
                }
            });
        }, () => {
            this.props.hideLoading();
        });
    }

    validateWatrVerifyTaxData = (ssnDecrypted: string, _incomeIrsYear?: number, _incomeIrsYearGross?: number, _employmentType?: string | number) => {
        return {
            ssnDecrypted: ssnDecrypted != null && ssnDecrypted.length == 9,
            incomeIrsYear: true,
            incomeIrsYearGross: true,
            startDate: true,
            endDate: true,
            incomeGross: true
        };
    };

    validateWatrVerifyStubData = (
        startNewDate: string,
        endNewDate: string,
        amount: number,
        _ssnDecrypted?: string,
        employmentType?: string | number,
        incomeIrsYear?: number,
        incomeIrsYearGross?: number
    ) => {
        if (isSelfEmployed(employmentType)) {
            const year = Number(incomeIrsYear) || 0;
            const gross = Number(incomeIrsYearGross) || 0;

            return {
                ssnDecrypted: true,
                incomeIrsYear: year > 0,
                incomeIrsYearGross: gross > 0,
                startDate: true,
                endDate: true,
                incomeGross: amount.toString() != '' && amount > 0
            };
        }

        return {
            ssnDecrypted: true,
            incomeIrsYear: true,
            incomeIrsYearGross: true,
            startDate: startNewDate != '' && this.validateDate(startNewDate),
            endDate: endNewDate != '' && this.validateDate(endNewDate),
            incomeGross: amount.toString() != '' && amount > 0
        };
    };

    validateDate = (newDate: string) => {
        const inputDate = moment(newDate, "YYYY-MM-DD", true);
        const cutoffDate = moment("1999-01-01", "YYYY-MM-DD");
        return inputDate.isValid() && inputDate.isAfter(cutoffDate);
    }

    isWatrVerifyDataValid = (validation: IWageAndTravelVerifyValidation) => {
        let { ssnDecrypted, incomeIrsYear, incomeIrsYearGross, startDate, endDate, incomeGross } = validation;
        return ssnDecrypted && incomeIrsYear && incomeIrsYearGross && startDate && endDate && incomeGross;
    };

    getStubValidationErrors = (validation: IWageAndTravelVerifyValidation): string[] => {
        const errors: string[] = [];
        if (!validation.incomeIrsYear) errors.push('Tax year');
        if (!validation.incomeIrsYearGross) errors.push('Tax year gross');
        if (!validation.startDate) errors.push('Start date');
        if (!validation.endDate) errors.push('End date');
        if (!validation.incomeGross) errors.push('Gross amount');
        return errors;
    };

    handleVerifyTax = (requestId: number, ssnDecrypted: string, incomeIrsYear: number, incomeIrsYearGross: number, requiresEmail: boolean) => {
        let requestData = this.state.list.find(x => x.id == requestId);

        let taxParams: VerifyTaxParams = { requestId, ssnDecrypted, incomeIrsYear, incomeIrsYearGross };

        if (!requiresEmail) {
            this.sendVerifyTax(taxParams);
        } else {
            this.setState({
                modal: {
                    show: true,
                    data: requestData,
                    type: WageAndTravelViewType.ApprovalEmail
                },
                approvalEmailType: ApprovalEmailType.VerifyTax,
                approvalData: taxParams
            });
        }
    }

    sendVerifyTax = ({ requestId, ssnDecrypted, incomeIrsYear, incomeIrsYearGross }: VerifyTaxParams, approvalEmail: ApprovalEmailContract = null) => {
        let requestData = this.state.list.find(x => x.id == requestId) || this.state.view?.data;
        const taxLabelData = requestData || { employmentType: undefined, taxDocumentFile: false, firstName: '', lastName: '' };
        let validation = this.validateWatrVerifyTaxData(
            ssnDecrypted,
            incomeIrsYear,
            incomeIrsYearGross,
            requestData?.employmentType
        );
        let isValid = this.isWatrVerifyDataValid(validation);

        this.setState({
            validation,
            isValid,
            isDirty: true
        }, () => {
            if (this.state.isValid) {
                this.props.showLoading(getVerifyTaxLoadingMessage(taxLabelData)).then(() => {
                    this.props.verifyTax(requestId, ssnDecrypted, incomeIrsYear, incomeIrsYearGross, approvalEmail)
                        .then(response => {
                            if (response.data.success) {
                                let newReq = response.data.results;
                                let updatedList = getUpdatedList(this.state.list, newReq);

                                this.setState({
                                    list: updatedList,
                                    modal: {
                                        show: false,
                                        data: this.state.modal.data,
                                        type: null
                                    },
                                    approvalData: null
                                }, () => {
                                    if (!this._isMounted) {
                                        this.props.hideLoading();
                                        return;
                                    }

                                    const finishVerifyTaxSuccess = () => {
                                        if (!this._isMounted) {
                                            this.props.hideLoading();
                                            return;
                                        }

                                        this.updateWageAndTravelView(true, false);
                                        toast.success(getVerifyTaxSuccessMessage(this.state.view.data || taxLabelData));
                                    };

                                    this.props.getTravelDetails(this.props.centerId, requestId, this.props.isSuperUser)
                                        .then(detailsResponse => {
                                            if (!this._isMounted) {
                                                this.props.hideLoading();
                                                return;
                                            }

                                            if (detailsResponse?.data?.success && detailsResponse?.data?.results) {
                                                let { watrBasicDetail, watrReimbursements, watrTravelLogs } = detailsResponse.data.results;

                                                if (watrBasicDetail) {
                                                    let currentItem = this.state.list.find(x => x.id == requestId);

                                                    if (currentItem) {
                                                        watrBasicDetail.roundTripInstances = currentItem.roundTripInstances;
                                                    }

                                                    watrBasicDetail.logs = _.orderBy(watrTravelLogs || [], ['logDate'], 'desc');

                                                    let refreshedList = getUpdatedList(this.state.list, watrBasicDetail);
                                                    let updatedViewData = refreshedList.find(x => x.id == requestId);

                                                    this.setState({
                                                        list: refreshedList,
                                                        view: {
                                                            ...this.state.view,
                                                            data: updatedViewData || watrBasicDetail,
                                                            reimbursements: watrReimbursements
                                                        }
                                                    }, finishVerifyTaxSuccess);
                                                    return;
                                                }
                                            }

                                            finishVerifyTaxSuccess();
                                        })
                                        .catch(() => {
                                            finishVerifyTaxSuccess();
                                        });
                                });
                            } else {
                                const fallback = getVerifyTaxErrorMessage(taxLabelData);
                                const message = response?.data?.results || response?.data?.message || fallback;
                                toast.error(typeof message === 'string' ? message : fallback);
                                this.props.hideLoading();
                            }
                        })
                        .catch((error: AxiosError) => {
                            toast.error(getVerifyTaxErrorMessage(taxLabelData));
                            this.props.hideLoading();
                        });
                });
            } else {
                toast.error('Please correct the validation errors before verifying.');
            }
        });
    }

    handleVerifyStub = (
        requestId: number,
        startDate: string,
        endDate: string,
        amount: number,
        paystubs: IPaystub[],
        requiresEmail: boolean,
        ssnDecrypted?: string,
        incomeIrsYear?: number,
        incomeIrsYearGross?: number
    ) => {
        let requestData = this.state.list.find(x => x.id == requestId);

        let stubParams: VerifyStubParams = {
            requestId,
            startDate,
            endDate,
            amount,
            paystubs,
            ssnDecrypted,
            incomeIrsYear,
            incomeIrsYearGross
        };

        if (!requiresEmail) {
            this.sendVerifyStub(stubParams);
        } else {
            this.setState({
                modal: {
                    show: true,
                    data: requestData,
                    type: WageAndTravelViewType.ApprovalEmail
                },
                approvalEmailType: ApprovalEmailType.VerifyPayStub,
                approvalData: stubParams
            });
        }
    }

    sendVerifyStub = ({
        requestId,
        startDate,
        endDate,
        amount,
        paystubs,
        ssnDecrypted,
        incomeIrsYear,
        incomeIrsYearGross
    }: VerifyStubParams, approvalEmail: ApprovalEmailContract = null) => {
        let requestData = this.state.list.find(x => x.id == requestId) || this.state.view?.data;
        let validation = this.validateWatrVerifyStubData(
            startDate,
            endDate,
            amount,
            ssnDecrypted,
            requestData?.employmentType,
            incomeIrsYear,
            incomeIrsYearGross
        );
        let isValid = this.isWatrVerifyDataValid(validation);

        this.setState({
            validation,
            isValid,
            isDirty: true
        }, () => {
            if (this.state.isValid) {
                this.props.showLoading('Verifying Income...').then(() => {
                    this.props.verifyStub(
                        requestId,
                        startDate,
                        endDate,
                        amount,
                        paystubs || [],
                        approvalEmail,
                        ssnDecrypted,
                        incomeIrsYear,
                        incomeIrsYearGross
                    )
                        .then(response => {
                            if (response.data.success) {
                                let newReq = response.data.results;
                                let updatedList = getUpdatedList(this.state.list, newReq);

                                this.setState({
                                    list: updatedList,
                                    modal: {
                                        show: false,
                                        data: this.state.modal.data,
                                        type: null
                                    },
                                    approvalData: null
                                }, () => {
                                    if (!this._isMounted) {
                                        this.props.hideLoading();
                                        return;
                                    }

                                    const finishVerifyStubSuccess = () => {
                                        if (!this._isMounted) {
                                            this.props.hideLoading();
                                            return;
                                        }

                                        this.updateWageAndTravelView(true, false);
                                        toast.success(this.state.view.data.firstName + ' ' + this.state.view.data.lastName + ' income has been verified.');
                                    };

                                    this.props.getTravelDetails(this.props.centerId, requestId, this.props.isSuperUser)
                                        .then(detailsResponse => {
                                            if (!this._isMounted) {
                                                this.props.hideLoading();
                                                return;
                                            }

                                            if (detailsResponse?.data?.success && detailsResponse?.data?.results) {
                                                let { watrBasicDetail, watrReimbursements, watrTravelLogs } = detailsResponse.data.results;

                                                if (watrBasicDetail) {
                                                    let currentItem = this.state.list.find(x => x.id == requestId);

                                                    if (currentItem) {
                                                        watrBasicDetail.roundTripInstances = currentItem.roundTripInstances;
                                                    }

                                                    watrBasicDetail.logs = _.orderBy(watrTravelLogs || [], ['logDate'], 'desc');

                                                    let refreshedList = getUpdatedList(this.state.list, watrBasicDetail);
                                                    let updatedViewData = refreshedList.find(x => x.id == requestId);

                                                    this.setState({
                                                        list: refreshedList,
                                                        view: {
                                                            ...this.state.view,
                                                            data: updatedViewData || watrBasicDetail,
                                                            reimbursements: watrReimbursements
                                                        }
                                                    }, finishVerifyStubSuccess);
                                                    return;
                                                }
                                            }

                                            finishVerifyStubSuccess();
                                        })
                                        .catch(() => {
                                            finishVerifyStubSuccess();
                                        });
                                });
                            } else {
                                const message = response.data?.results || response.data?.message || 'Unable to verify income.';
                                toast.error(typeof message === 'string' ? message : 'Unable to verify income.');
                                this.props.hideLoading();
                            }
                        })
                        .catch((error: AxiosError) => {
                            const msg = error.response?.data?.message ?? error.response?.data?.results ?? 'Unable to verify income.';
                            toast.error(typeof msg === 'string' ? msg : 'Unable to verify income.');
                            this.props.hideLoading();
                        });
                });
            } else {
                const errors = this.getStubValidationErrors(validation);
                const message = errors.length > 0
                    ? `Please correct: ${errors.join(', ')}.`
                    : 'Please correct the validation errors before verifying.';
                toast.error(message);
            }
        });
    }

    handleVerifyAmount = (requestId: number, status: WageAndTravelStatus, sendEmail: boolean, amount: number, requiresEmail: boolean) => {
        let requestData = this.state.list.find(x => x.id == requestId);

        let amountParams: VerifyAmountParams = { requestId, status, sendEmail, amount };

        if (!requiresEmail) {
            this.sendVerifyAmount(amountParams);
        } else {
            this.setState({
                modal: {
                    show: true,
                    data: requestData,
                    type: WageAndTravelViewType.ApprovalEmail
                },
                approvalEmailType: ApprovalEmailType.VerifyAmount,
                approvalData: amountParams
            });
        }
    }

    sendVerifyAmount = ({ requestId, status, sendEmail, amount }: VerifyAmountParams, approvalEmail: ApprovalEmailContract = null) => {
        this.props.showLoading('Verifying amount...').then(() => {
            this.props.verifyAmount(requestId, status, sendEmail, amount, approvalEmail)
                .then(response => {
                    if (response.data.success) {
                        let newReq = response.data.results;
                        newReq.logs = [];

                        let updatedList = getUpdatedList(this.state.list, newReq);

                        this.setState({
                            list: updatedList,
                            modal: {
                                show: true,
                                data: this.state.modal.data,
                                type: null
                            },
                            approvalData: null
                        }, () => {
                            this.updateWageAndTravelView(false, false, true);

                            toast.success(this.state.view.data.firstName + ' ' + this.state.view.data.lastName + ' amount has been verified.');

                            this.getData(this.state.area, this.state.category, true);
                        });
                    } else {
                        const msg = response.data?.message ?? 'Unable to verify amount.';
                        toast.error(msg);
                        return;
                    }
                })
                .catch((error: AxiosError) => {
                    const errData = error.response?.data as { message?: string; Message?: string; results?: unknown } | undefined;
                    const msg = errData?.message ?? errData?.Message ?? error.message ?? 'Unable to verify amount.';
                    toast.error(typeof msg === 'string' ? msg : 'Unable to verify amount.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleVerifyTravel = async (travelRequestId: number, requestId: number, roundTripMiles: number, hotelLodgingExpense: number, flightAndTrainExpense: number, carServiceExpense: number, dependentCareExpense: number,
        mealExpense: number, isMilesOverWritten: boolean, overrideMiles: number, isMealsOverWritten: boolean, overrideMeals: number,
        isCarServiceExpenseOverridden: boolean, overrideCarServiceExpense: number,
        isDependentCareExpenseOverridden: boolean, overrideDependentCareExpense: number,
        isHotelLodgingExpenseOverridden: boolean, overrideHotelLodgingExpense: number,
        requiresEmail: boolean
    ) => {
        let requestData = this.state.list.find(x => x.id == requestId);

        let travelParams: TravelVerificationParams = {
            travelRequestId, roundTripMiles, hotelLodgingExpense, flightAndTrainExpense, carServiceExpense, dependentCareExpense,
            mealExpense, isMilesOverWritten, overrideMiles, isMealsOverWritten, overrideMeals,
            isCarServiceExpenseOverridden, overrideCarServiceExpense,
            isDependentCareExpenseOverridden, overrideDependentCareExpense,
            isHotelLodgingExpenseOverridden, overrideHotelLodgingExpense
        };

        if (!requiresEmail) {
            this.sendVerifyTravel(travelParams);
        } else {
            this.setState({
                modal: {
                    show: true,
                    data: requestData,
                    type: WageAndTravelViewType.ApprovalEmail
                },
                approvalEmailType: ApprovalEmailType.VerifyExpense,
                approvalData: travelParams
            });
        }
    }

    sendVerifyTravel = ({ travelRequestId, roundTripMiles, hotelLodgingExpense, flightAndTrainExpense, carServiceExpense, dependentCareExpense,
        mealExpense, isMilesOverWritten, overrideMiles, isMealsOverWritten, overrideMeals,
        isCarServiceExpenseOverridden, overrideCarServiceExpense,
        isDependentCareExpenseOverridden, overrideDependentCareExpense,
        isHotelLodgingExpenseOverridden, overrideHotelLodgingExpense }: TravelVerificationParams, approvalEmail: ApprovalEmailContract = null) => {

        this.props.showLoading('Approving claim…').then(() => {
            this.props.verifyTravel(travelRequestId, roundTripMiles, hotelLodgingExpense, flightAndTrainExpense, carServiceExpense, dependentCareExpense,
                mealExpense, isMilesOverWritten, overrideMiles, isMealsOverWritten, overrideMeals,
                isCarServiceExpenseOverridden, overrideCarServiceExpense,
                isDependentCareExpenseOverridden, overrideDependentCareExpense,
                isHotelLodgingExpenseOverridden, overrideHotelLodgingExpense,
                approvalEmail
            )
                .then(async (response) => {
                    if (response.data.success) {
                        let newReq = response.data.results;

                        this.setState({
                            modal: {
                                show: false,
                                data: this.state.modal.data,
                                type: null
                            },
                            approvalData: null
                        });

                        toast.success(`${newReq.firstName} ${newReq.lastName} expense has been verified.`);
                        this.handleCancelView();
                        await this.refreshActiveList();
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error('Unable to verify expense.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleConfirmDonation = (requestId: number, signOffInitials: string) => {
        this.props.showLoading('Confirming Donation...').then(() => {
            this.props.confirmDonation(requestId, signOffInitials)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            modal: {
                                data: this.state.modal.data,
                                show: false,
                                type: this.state.modal.type,
                            }
                        }, () => {
                            toast.success('Donation confirmed!');
                            this.getData(this.state.area, this.state.category, true);
                        });
                    } else {
                        toast.error('Unable to confirm donation: ' + response.data.message);
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error('Unable to confirm donation.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleUpdateDonationDate = (requestId: number, donationDate: string) => {
        this.props.showLoading('Confirming Donation...').then(() => {
            this.props.updateDonationDate(requestId, donationDate)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            modal: {
                                data: this.state.modal.data,
                                show: false,
                                type: this.state.modal.type,
                            }
                        }, () => {
                            toast.success('Donation date updated.');
                            this.getData(this.state.area, this.state.category, true);
                        });
                    } else {
                        toast.error('Unable to update donation data: ' + response.data.message);
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error('Unable to update donation data.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleReimbursementEntry = (type: number, amount: number, confirmationCode: string, date: string, closeAdvancedReimbursementCard?: boolean) => {
        let message = 'Adding reimbursement entry, one moment please...';

        this.props.showLoading(message).then(() => {
            this.props.saveReimbursementEntry(this.state.view.data.id, type, amount, confirmationCode, date, closeAdvancedReimbursementCard)
                .then(response => {
                    const payload = response?.data as {
                        success?: boolean;
                        Success?: boolean;
                        results?: any;
                        Results?: any;
                        message?: string;
                    } | undefined;
                    const ok = payload?.success === true || payload?.Success === true;
                    if (!ok) {
                        const err =
                            (typeof payload?.results === 'string' && payload.results)
                            || (typeof payload?.Results === 'string' && payload.Results)
                            || payload?.message
                            || 'Unable to create reimbursement.';
                        toast.error(err);
                        return;
                    }

                    let reimbursements = _.cloneDeep(this.state.view.reimbursements).map(item => {
                        return item;
                    });

                    const results = payload.results ?? payload.Results;
                    if (results?.newReimbursement) {
                        reimbursements.push(results.newReimbursement);
                    }

                    var status = results?.newRequestStatus;

                    let requestList = _.cloneDeep(this.state.list).map(item => {
                        if (item.id == this.state.view.data.id) {
                            item.status = status;
                        }

                        return item;
                    });

                    const requestId = this.state.view.data.id;
                    const viewType = this.state.view.type;

                    this.setState({
                        list: requestList,
                        view: patchWatrViewState(this.state.view, {
                            reimbursements,
                            openReconcileReimbursementEntry: false
                        })
                    }, () => {
                        this.getData(this.state.area, this.state.category, true);
                        if (this.state.view.show && requestId) {
                            this.getRequestData(requestId, viewType, false);
                        }
                        toast.success('Reimbursement added successfully');
                    });
                })
                .catch((error: AxiosError) => {
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleReimbursementUpdate = (requestId: number, reimbursementId: number, type: number, amount: number, confirmationCode: string, date: string) => {
        let message = 'Updating reimbursement entry, one moment please...';

        this.props.showLoading(message).then(() => {
            this.props.updateReimbursement(requestId, reimbursementId, type, amount, confirmationCode, date)
                .then(response => {
                    let results = response.data.results;

                    let reimbursements = _.cloneDeep(this.state.view.reimbursements).map(item => {
                        if (item.id == reimbursementId) {
                            item.amount = results.amount;
                            item.confirmationCode = results.confirmationCode;
                            item.date = results.date;
                            item.reimbursementType = results.reimbursementType;
                        }

                        return item;
                    });

                    this.setState({
                        view: { ...this.state.view, reimbursements }
                    }, () => {
                        toast.success('Reimbursement updated successfully');
                    });
                })
                .catch((error: AxiosError) => {
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleAuditUpdate = (requestId: number, type: WageAndTravelType, status: WageAndTravelStatus, reimbursementAmount: number, donationDate: string, incomePercentCovered: number, sixtyDayOverride: boolean, ninetyDayLWROverride: boolean, expenseLimitOverride: boolean) => {
        let message = 'Updating request, one moment please...';

        this.props.showLoading(message).then(() => {
            this.props.updateAudit(requestId, type, status, reimbursementAmount, donationDate, incomePercentCovered, sixtyDayOverride, ninetyDayLWROverride, expenseLimitOverride)
                .then(response => {
                    if (response.data.success) {
                        let { firstName, lastName } = this.state.view.data;

                        this.setState({
                            view: buildWatrViewState({
                                data: null,
                                show: false,
                                reimbursements: []
                            })
                        }, () => {
                            this.refreshDataAfterUpdate();
                            toast.success(`${firstName} ${lastName}'s request has been updated.`);
                        });
                    } else {
                        toast.success('Unable to update request: ' + response.data.message);
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        })
    }

    handleReconcileTransactions = (requestId: number) => {
        const row = this.state.list.find(x => x.id === requestId);
        const hasPendingTravel = (row?.requestTravels || []).some(
            x => x.status === WageAndTravelReimbursementRequestStatus.PendingApproval
        );
        const progress = row ? readAdvancedProgressForBuckets(row) : undefined;
        const needsVerifyTravel =
            isAdvancedDsArea(this.state.area)
            && hasPendingTravel
            && progress?.statusCode !== AdvancedWorkflowStatus.ReadyToReconcile
            && (
                row?.status === WageAndTravelStatus.PendingAdvancedReimbursement
                || progress?.statusCode === AdvancedWorkflowStatus.PendingNkrVerification
                || progress?.statusCode === AdvancedWorkflowStatus.AwaitingDonorSubmission
            );

        if (needsVerifyTravel) {
            this.getRequestData(requestId, WageAndTravelViewType.VerifyTravel);
            return;
        }

        this.getRequestData(requestId, WageAndTravelViewType.RequestData, true);
    }

    handleCancelView = () => {
        this.setState({
            view: { ...EMPTY_WATR_VIEW },
            additionalInfoSidebar: {
                show: false,
                data: null,
                displayType: 0,
                fileUrl: '',
                fileIds: [],
                currentIndex: 0,
                totalFiles: 0,
                fileIdToLineItemsMap: new Map(),
                onApproveLineItems: undefined,
                onRequestReviewLineItems: undefined,
                onExpenseTypeChange: undefined,
                onExpenseTypeApproved: undefined,
                onRefreshLineItems: undefined,
                onReviewRequiredStateChange: undefined,
                viewerDocs: [],
                onViewerDocChange: undefined
            },
            travelId: 0,
            isTravel: false
        }, () => {
            this.setUrlParameters();
        });
    }

    refreshActiveList = (): Promise<void> => {
        const area = this.state.area;
        const category = this.state.category;
        const organType = this.resolveFetchOrganType(category);
        const search = this.state.search;
        const countsStartDate = search.startDate;
        const countsEndDate = search.endDate;

        return Promise.all([
            this.props.getRequestCounts(
                this.props.centerId,
                area,
                category,
                countsStartDate,
                countsEndDate,
                this.props.isSuperUser,
                organType
            ),
            this.props.getRequestList(
                this.props.centerId,
                area,
                category,
                search.startDate,
                search.endDate,
                this.props.isSuperUser,
                organType
            )
        ]).then(([countsResponse, listResponse]) => {
            if (!this._isMounted) {
                return;
            }

            if (!countsResponse?.data?.success || !listResponse?.data?.success) {
                return;
            }

            const advancedListState = this.applyAdvancedListForArea(listResponse.data.results || [], area);

            this.setState({
                list: advancedListState.list,
                advancedSourceList: advancedListState.advancedSourceList,
                counts: countsResponse.data.results,
                fetching: false
            });
        });
    }

    handleCancelAdditionalInfoSidebar = () => {
        this.setState({
            additionalInfoSidebar: {
                show: false,
                data: null,
                displayType: 0,
                fileUrl: '',
                fileIds: [],
                currentIndex: 0,
                totalFiles: 0,
                fileIdToLineItemsMap: new Map(),
                onApproveLineItems: undefined,
                onRequestReviewLineItems: undefined,
                onExpenseTypeChange: undefined,
                onExpenseTypeApproved: undefined,
                onRefreshLineItems: undefined,
                onReviewRequiredStateChange: undefined,
                viewerDocs: [],
                onViewerDocChange: undefined
            }
        }, () => {
            this.setUrlParameters();
        });
    }

    handleClose = () => {
        if (this.state.modal.type == WageAndTravelViewType.DeclineRequest) {
            if (this.state.restoreSidebarAfterDeclineClose) {
                this.setState({
                    view: patchWatrViewState(this.state.view, { show: true }),
                    modal: {
                        show: false,
                        data: this.state.modal.data,
                        type: this.state.modal.type
                    },
                    travelId: 0,
                    isTravel: false,
                    declineType: 'Lost Wage',
                    restoreSidebarAfterDeclineClose: false
                });
            } else {
                this.setState({
                    modal: {
                        show: false,
                        data: this.state.modal.data,
                        type: this.state.modal.type
                    },
                    travelId: 0,
                    isTravel: false,
                    declineType: 'Lost Wage',
                    restoreSidebarAfterDeclineClose: false
                });
            }
        } else if (this.state.modal.type == WageAndTravelViewType.ApprovalEmail) {
            this.setState({
                view: patchWatrViewState(this.state.view, { show: true }),
                modal: {
                    show: false,
                    data: this.state.modal.data,
                    type: this.state.modal.type
                },
                travelId: 0,
                isTravel: false,
                declineType: 'Lost Wage'
            });
        } else {
            this.setState({
                modal: {
                    show: false,
                    data: this.state.modal.data,
                    type: this.state.modal.type,
                },
                travelId: 0,
                isTravel: false,
                declineType: 'Lost Wage'
            });
        }
    }

    showDeclineModal = (requestId: number, isTravel: boolean = false, travelId: number = 0, hasLineItemsSelected?: boolean) => {
        let requestData = this.state.list.find(x => x.id == requestId);
        const declineType = isTravel ? 'Expense' : 'Lost Wage';

        this.setState({
            modal: {
                show: true,
                data: requestData,
                type: WageAndTravelViewType.DeclineRequest
            },
            travelId: travelId || 0,
            isTravel: isTravel,
            declineType: declineType,
            hasLineItemsSelected: isTravel ? hasLineItemsSelected : undefined,
            restoreSidebarAfterDeclineClose: this.state.view.show
        });
    }

    showAdditionalInfoSidebar = (docType: number, lookupId: number, fileUrl: string, totalFiles?: number, fileIds?: number[], currentIndex?: number, fileIdToLineItemsMap?: Map<number, any[]>, onApproveLineItems?: (lineItemIds: number[]) => Promise<void>, onRequestReviewLineItems?: (lineItemIds: number[]) => Promise<void>, onExpenseTypeChange?: (expenseType: number | null) => void, onExpenseTypeApproved?: (expenseType: number) => void, onRefreshLineItems?: () => Promise<void>, onReviewRequiredStateChange?: (lineItemIds: number[], reviewRequired: boolean) => void, viewerDocs?: IWatrViewerDocument[], onViewerDocChange?: (docType: number, index: number) => void) => {
        this.setState({
            additionalInfoSidebar: {
                show: true,
                data: this.state.view.data,
                displayType: docType,
                fileUrl: fileUrl || '',
                fileIds: fileIds || [],
                currentIndex: currentIndex !== undefined ? currentIndex : 0,
                totalFiles: totalFiles || (viewerDocs ? viewerDocs.length : 0),
                fileIdToLineItemsMap: fileIdToLineItemsMap || new Map(),
                onApproveLineItems: onApproveLineItems,
                onRequestReviewLineItems: onRequestReviewLineItems,
                onExpenseTypeChange: onExpenseTypeChange,
                onExpenseTypeApproved: onExpenseTypeApproved,
                onRefreshLineItems: onRefreshLineItems,
                onReviewRequiredStateChange: onReviewRequiredStateChange,
                viewerDocs: viewerDocs || [],
                onViewerDocChange: onViewerDocChange
            },
        });
    }

    fetchFileUrl = (docType: FileDocumentType, lookupId: number): Promise<string> => {
        this.props.showLoading('Loading file...');

        return this.props.downloadFile(docType, lookupId)
            .then((response: any) => {
                const fileUrl = URL.createObjectURL(response.data);
                return fileUrl;
            })
            .catch((error) => {
                console.error('Error fetching file:', error);
                //throw error;
                return null;
            })
            .finally(() => {
                this.props.hideLoading();
            });
    }

    handleCloseViewModal = () => {
        this.setState({
            viewmodal: {
                show: false,
                data: null
            }
        });
    }

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    handleAuditYearEnd = (requestId: number) => {
        this.getRequestDataForAudit(requestId);
    }

    handleActionRequest = (id: number, viewType: WageAndTravelViewType) => {
        let data = this.state.list.find(x => x.id == id);

        switch (viewType) {
            case WageAndTravelViewType.RequestData:
            case WageAndTravelViewType.ReimburseTravel:
            case WageAndTravelViewType.ReimburseWage:
            case WageAndTravelViewType.ReimburseWageAudit:
                this.getRequestData(id, viewType);
                break;

            case WageAndTravelViewType.ConfirmDonation:
            case WageAndTravelViewType.CancelRequest:
            case WageAndTravelViewType.AdditionalDays:
            case WageAndTravelViewType.PaymentError:
            case WageAndTravelViewType.ApproveWeekReimbursements:
                this.setState({
                    modal: {
                        show: true,
                        data,
                        type: viewType
                    },
                });
                break;

            case WageAndTravelViewType.VerifyTravel:
            case WageAndTravelViewType.VerifyWage:
                this.getRequestData(id, viewType);
                break;

            case WageAndTravelViewType.ConfirmTravelReiembursement:
                const travelData = this.state.list.find(x => x.id == id && x.achReimbursementType == ReimbursementType.TravelAndLodging);
                this.handleConfirmReiembursement(travelData, ReimbursementType.TravelAndLodging);
                break;

            case WageAndTravelViewType.ConfirmWageReiembursement:
                const wageData = this.state.list.find(x => x.id == id && x.achReimbursementType == ReimbursementType.Wages);
                this.handleConfirmReiembursement(wageData, ReimbursementType.Wages);
                break;

            default:
                this.setState({
                    view: buildWatrViewState({
                        type: viewType,
                        show: true,
                        data: data,
                        reimbursements: []
                    })
                });
        }
    }

    handleAdvancedWorkflowAction = (id: number, action: AdvancedWorkflowActionType) => {
        let dispatcher: ((requestId: number, reason: string) => Promise<IBaseResponse>) | null = null;
        let successMessage = '';

        if (action === 'approve') {
            dispatcher = this.props.approveAdvancedReimbursement;
            successMessage = 'Advanced reimbursement application approved.';
        } else if (action === 'deny') {
            dispatcher = this.props.denyAdvancedReimbursement;
            successMessage = 'Advanced reimbursement application declined.';
        } else if (action === 'hold') {
            dispatcher = this.props.holdAdvancedReimbursement;
            successMessage = 'Advanced reimbursement placed on hold.';
        } else if (action === 'release') {
            dispatcher = this.props.releaseAdvancedReimbursement;
            successMessage = 'Advanced reimbursement hold released.';
        } else if (action === 'activate') {
            dispatcher = this.props.activateAdvancedReimbursement;
            successMessage = 'Advanced reimbursement card activated.';
        }

        if (dispatcher == null) {
            return;
        }

        dispatcher(id, '')
            .then(response => {
                let payload = response != null ? (response.data as { success?: boolean; Success?: boolean; results?: any; Results?: any }) : null;
                let ok = payload != null && (payload.success === true || payload.Success === true);
                if (ok) {
                    toast.success(successMessage);
                    this.refreshDataAfterUpdate();
                } else {
                    let errMsg = '';
                    if (payload != null) {
                        let resultsField = payload.results ?? payload.Results;
                        if (typeof resultsField === 'string') {
                            errMsg = resultsField;
                        }
                    }
                    toast.error(errMsg.length > 0 ? errMsg : 'Unable to update advanced reimbursement state.');
                }
            })
            .catch((err: any) => {
                let errMsg = '';
                let data = err != null ? err.response && err.response.data : null;
                if (data != null) {
                    let resultsField = data.results ?? data.Results;
                    if (typeof resultsField === 'string') {
                        errMsg = resultsField;
                    }
                }
                toast.error(errMsg.length > 0 ? errMsg : 'Unable to update advanced reimbursement state.');
            });
    }

    handleResendInvite = (id: number) => {
        let message = 'Resending invitation, one moment please...';
        let reqId = id;

        this.props.showLoading(message).then(() => {
            this.props.resendInvitation(reqId)
                .then(response => {
                    const payload = response.data as { success?: boolean; Success?: boolean; message?: string; Message?: string };
                    const ok = payload.success === true || payload.Success === true;
                    if (ok) {
                        toast.success('Invitation sent successfully');
                        this.refreshDataAfterUpdate();
                    } else {
                        const errMsg = payload.message ?? payload.Message ?? '';
                        toast.error('Unable to Resend Invitation: ' + errMsg);
                    }
                })
                .catch((error: AxiosError) => {
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleSaveLogEntry = (type: number, comments: string, file: File) => {
        let message = 'Creating log entry, one moment please...';
        let reqId = this.state.view.data.id;

        this.props.showLoading(message).then(() => {
            this.props.saveLogEntry(reqId, type, comments, file)
                .then(response => {
                    if (response.data.success) {
                        let viewData = _.cloneDeep(this.state.view.data);

                        if (viewData.logs == undefined)
                            viewData.logs = [];

                        viewData.logs.push(response.data.results);

                        this.setState({
                            view: patchWatrViewState(this.state.view, {
                                show: true,
                                type: WageAndTravelViewType.RequestData,
                                data: viewData
                            })
                        }, () => {
                            toast.success('Log entry updated successfully');
                        });
                    } else {
                        toast.error('Unable to create entry');
                    }
                })
                .catch((error: AxiosError) => {
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleUpdateLogEntry = (logId: number, type: number, comments: string, file: File) => {
        let message = 'Creating log entry, one moment please...';
        let reqId = this.state.view.data.id;

        this.props.showLoading(message).then(() => {
            this.props.updateLogEntry(reqId, logId, type, comments, file)
                .then(response => {
                    if (response.data.success) {
                        let logId = response.data.results.id;

                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == reqId) {
                                item.logs = item.logs.map(logItem => {
                                    if (logItem.id == logId)
                                        return response.data.results;

                                    return logItem;
                                })
                            }

                            return item;
                        });

                        let data = list.find(x => x.id == reqId);

                        this.setState({
                            list,
                            view: patchWatrViewState(this.state.view, {
                                show: true,
                                type: WageAndTravelViewType.RequestData,
                                data
                            })
                        }, () => {
                            toast.success('Log entry updated successfully');
                        });
                    } else {
                        toast.error('Unable to create entry');
                    }
                })
                .catch((error: AxiosError) => {
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleDeleteLogEntry = (logId: number) => {
        let reqId = this.state.view.data.id;

        this.props.showLoading('Deleting log entry, one moment please...').then(() => {
            this.props.deleteLogEntry(reqId, logId)
                .then(response => {
                    if (response.data.success) {
                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == reqId) {
                                item.logs = item.logs.filter(logItem => logItem.id != logId);
                            }
                            return item;
                        });

                        let data = list.find(x => x.id == reqId);

                        this.setState({
                            list,
                            view: patchWatrViewState(this.state.view, {
                                type: WageAndTravelViewType.RequestData,
                                show: true,
                                data
                            })
                        }, () => {
                            toast.success('Log entry delete successfully');
                        });
                    }
                })
                .catch((error: AxiosError) => {
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    updateWageAndTravelView = (show: boolean, showAdditional: boolean, verifyAmountRefresh: boolean = false) => {
        let newData = this.state.list.find(x => x.id == this.state.view.data.id);

        let additionalInfoSidebar = { ...this.state.additionalInfoSidebar, show: showAdditional }

        if (verifyAmountRefresh) {
            additionalInfoSidebar = {
                data: null,
                displayType: 0,
                fileUrl: '',
                show: false,
                fileIds: [],
                currentIndex: 0,
                totalFiles: 0,
                fileIdToLineItemsMap: new Map(),
                onApproveLineItems: undefined,
                onRequestReviewLineItems: undefined,
                onExpenseTypeChange: undefined,
                onExpenseTypeApproved: undefined,
                onRefreshLineItems: undefined,
                onReviewRequiredStateChange: undefined,
                viewerDocs: [],
                onViewerDocChange: undefined
            }
        }

        this.setState({
            list: this.state.list,
            donationTypes: this.state.donationTypes,
            requestTypes: this.state.requestTypes,
            statusTypes: this.state.statusTypes,
            reimbursementTypes: this.state.reimbursementTypes,
            fetching: false,
            view: buildWatrViewState({
                show: show,
                data: newData,
                type: getViewTypeByStatus(newData.status),
                reimbursements: []
            }),
            additionalInfoSidebar
        }, () => {
            this.props.hideLoading();
        });
    }

    handleUpdateSearch = (property: string, value: any) => {
        let search = _.cloneDeep(this.state.search);

        if (property == 'center') {
            search[property] = parseInt(value);
        } else {
            search[property] = value;
        }

        this.setState({
            search
        });
    }

    handleUpdateCategory = (filterCategory: number) => {
        this.setState({
            category: WageAndTravelCategory.ToDo,
            subCategory: filterCategory
        }, () => {
            this.setUrlParameters();
        });
    }

    handleUpdateGroup = (filterGroup: any) => {
        this.setState({
            category: WageAndTravelCategory.ToDo,
            subGroup: filterGroup
        }, () => {
            this.setUrlParameters();
        });
    }

    handleUpdateDate = (startDate: string, endDate: string, dateChanged: number) => {
        const search = { ...this.state.search };
        if (dateChanged == 1) {
            search.startDate = startDate;
        } else {
            search.endDate = endDate;
        }
        this.setState({ search }, () => {
            this.setUrlParameters();
        });
    }

    handleDateSearch = () => {
        this.props.showLoading('Loading data...').then(() => {
            let { area, category } = this.state
            this.getData(area, category, true);
        }, () => {
            this.props.hideLoading();
        });
    }

    handleSearch = () => {
        let { firstName, lastName, email, birthDate, alias, center, area, startDate, endDate, category } = this.state.search;

        let centerId = this.props.centerId > 0 ? this.props.centerId : center;
        const organType = this.resolveFetchOrganType(category);

        this.props.showLoading('Looking for requests, one moment please...').then(() => {
            this.props.searchRequests(centerId, firstName, lastName, email, birthDate, alias, startDate, endDate, area, category, this.props.isSuperUser, organType)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            list: response.data.results,
                            organType,
                        }, () => {
                            this.setUrlParameters();
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleResetSearch = () => {
        let startDate = moment().subtract(60, 'days').format('YYYY-MM-DD');
        let endDate = moment().format('YYYY-MM-DD');

        if (this.state.category == WageAndTravelCategory.PendSurgery && this.props.isSuperUser) {
            startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            endDate = moment().addDays(30).format('YYYY-MM-DD');
        }

        const areaFromSection = getAreaFromSection(this.props.section);
        const resetArea = isAdvancedDsArea(areaFromSection) ? DsArea.Advanced : DsArea.Standard;

        this.setState({
            search: {
                firstName: '',
                lastName: '',
                email: '',
                birthDate: '',
                alias: '',
                center: 0,
                area: resetArea,
                category: 0,
                startDate,
                endDate
            }
        });
    }

    handlePageExport = () => {
        let fileName = WageAndTravelCategory.YearEndReport == this.state.category
            ? 'Watr_' + WageAndTravelCategory[this.state.category] + '_' + moment().subtract(1, 'years').format('YYYY') + '.csv'
            : 'Watr_' + WageAndTravelCategory[this.state.category] + '_' + moment().format('YYYY_MM_DD') + '.csv';

        const isAdvanced = isAdvancedDsArea(this.state.area);

        const headerOverrides: Record<string, string> = {
            rank: 'R#',
            country: 'International Donor',
            countryName: 'Country',
            createdDate: 'Created',
            donationConfirmed: 'Ready for Reimb',
            donationOrganType: 'Organ Type',
            lwrWeeklyAmount: 'LWR / Wk',
            lwrWeekCount: 'Wks',
            achRoutingNumber: 'Routing Number',
            bankInfo: 'Bank Info',
            fraudFlags: 'Possible Bank Error',
            pendingTransactionConfirmation: 'Chase Confirmation #',
            pendingTransactionAmount: 'Confirmation Amount',
            pendingTransactionSendOn: 'Send On',
            bankingFixesPending: 'Pending Donor Review',
            confirmationButton: 'Reimbursement Confirmation',
            advancedNetworkMilestoneLabel: 'Milestone Status',
            advancedNetworkMilestoneDate: 'Milestone Date',
        };

        let params: CsvExportParams = {
            columnGroups: true,
            allColumns: !isAdvanced,
            fileName: fileName,
            processHeaderCallback: (h: ProcessHeaderForExportParams) => {
                const col = h.column.getColDef();
                const field = col.field as string;
                return headerOverrides[field] ?? col.headerName ?? field;
            },
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();
                let colName = colDef.field;

                var result = params.value;

                if (colName == 'name' && params.node?.data) {
                    result = (params.node.data as IWatrRequest).name ?? '';
                } else if (colName == 'donationOrganType') {
                    result = params.value == 1 ? 'Liver' : 'Kidney';
                } else if (colName == 'reimbursementType') {
                    switch (params.value) {
                        case ReimbursementType.Wages:
                        case ReimbursementType.WagesForComplication:
                        case ReimbursementType.CreditReturnLostWageReimbursement:
                            result = 'Wages';
                            break;

                        case ReimbursementType.TravelAndLodging:
                        case ReimbursementType.TravelAndLodgingForComplication:
                            result = 'Travel';
                            break;

                        case ReimbursementType.DppReimbursement:
                            result = 'DPP';
                            break;

                        case ReimbursementType.DependentCare:
                            result = 'Dependent Care';
                            break;
                    }
                }

                return result;
            }
        };

        if (isAdvanced) {
            const advancedFields = this.props.isSuperUser
                ? ['rank', 'donationOrganType', 'donationType', 'centerAlias', 'donorAlias', 'name', 'isInternationallyEligible', 'status', 'advancedNetworkMilestoneLabel', 'advancedNetworkMilestoneDate']
                : ['rank', 'donationOrganType', 'donationType', 'donorAlias', 'name', 'isInternationallyEligible', 'status'];

            const availableKeys = this.columnApi
                ? this.columnApi.getAllColumns().map(c => c.getColId())
                : [];
            params.columnKeys = advancedFields.filter(f => availableKeys.indexOf(f) >= 0);
        }

        switch (this.state.category) {
            case WageAndTravelCategory.Transactions:
                this.gridApiTransactions.exportDataAsCsv(params);
                break;

            case WageAndTravelCategory.YearEndReport:
                this.gridApiYearEnd.exportDataAsCsv(params);
                break;

            case WageAndTravelCategory.PendRegistration:
                this.gridApiPendingRegistration.exportDataAsCsv(params);
                break;

            default:
                this.gridApi.exportDataAsCsv(params);
                break;
        }
    }

    handleChaseExport = (organType: OrganType) => {
        let organLabel = organType != null ? organType == OrganType.Kidney ? "K" : "L" : "K";
        this.props.showLoading('Exporting CSV file, one moment please...').then(() => {
            this.props.getChaseListExport(organType).then((response: any) => {
                downloadFile(response.data, `Chase-Exports_${organLabel}_${moment().format('YYYY.MM.DD')}.csv`, 'text/csv');
                this.props.hideLoading();
            });
        });
    }

    handleChangeOrganType = (values: OrganType | OrganType[]) => {
        let safeValues = Array.isArray(values) ? values : [values];
        if (safeValues.length == 0) return;
        let isReportsCategory = this.state.category == WageAndTravelCategory.YearEndReport
            || this.state.category == WageAndTravelCategory.Transactions;
        this.setState({ organTypes: safeValues }, () => {
            if (!isReportsCategory) {
                this.getData(this.state.area, this.state.category, true);
            }
        });
    }

    handleVerifyRoutingNumbers = () => {
        this.props.showLoading('Validating ACH Routing Numbers ...').then(() => {
            this.props.validateAchRouting()
                .then(response => {
                    if (response.data.success) {
                        this.props.hideLoading();

                        this.setState({
                            list: response.data.results,
                            counts: { ...this.state.counts, pendingPaymentTotal: response.data.results.length },
                            modal: {
                                ...this.state.modal,
                                show: true,
                                type: WageAndTravelViewType.ValidateBankInfo,
                                data: response.data.results.filter(f => f.bankInfo == 'Bank not found')
                            }
                        });

                    } else {
                        toast.error('Unable to validate routing numbers: ' + response.data.message);
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error('Unable to validate routing numbers.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleChaseTransactionUpload = (file: File) => {
        this.props.showLoading('Processing Chase Transaction file ...').then(() => {
            this.props.uploadChaseTransactions(file)
                .then(response => {
                    if (response.data.success) {

                        this.setState({
                            list: response.data.results,
                            modal: { ...this.state.modal, data: response.data.matchFailures }
                        }, () => {
                            if (!response.data.matchFailures) {
                                this.handleClose();
                            }
                        });
                    } else {
                        this.handleClose();
                        toast.error(`Unable to process Chase Transaction file: Please check file format.`);
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error('Unable to process Chase Transaction file.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleConfirmAll = () => {
        const items = this.state.list
            .filter(f => f.pendingTransactionConfirmation)
            .map(f => ({
                requestId: f.id,
                reimbursementType: f.achReimbursementType,
                amount: f.transactionAmount,
                confirmationCode: f.pendingTransactionConfirmation,
                date: moment(f.pendingTransactionSendOn).format("MM-DD-YYYY")
            }));

        if (items.length == 0) {
            toast.error('There are no reimbursements with a Chase Confirmation # to confirm.');
            return;
        }

        this.props.showLoading(`Confirming ${items.length} reimbursements ...`).then(() => {
            this.props.confirmReimbursements(items)
                .then(response => {
                    if (response.data.success) {
                        const { confirmed, failed, items: outcomes } = response.data.results;

                        this.setState({
                            counts: { ...this.state.counts, pendingPaymentTotal: this.state.counts.pendingPaymentTotal - confirmed },
                            list: [...this.state.list].filter(f => !outcomes.some(o => o.success && o.requestId == f.id && o.reimbursementType == f.achReimbursementType))
                        });

                        if (failed > 0) {
                            toast.error(`${confirmed} confirmed, ${failed} could not be confirmed.`, { autoClose: 8000 });
                        } else {
                            toast.success(`${confirmed} reimbursements confirmed.`);
                        }
                    } else {
                        toast.error('Unable to confirm Reiembursements: ' + response.data.message);
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error('Unable to confirm Reiembursements.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleConfirmReiembursement = (request: IWatrRequest, reimbursementType: ReimbursementType) => {
        this.props.showLoading(`Confirming Reiembursement for ${request.donorAlias} ...`).then(() => {
            const chaseFileDate = moment(request.pendingTransactionSendOn).format("MM-DD-YYYY");
            this.props.saveReimbursementEntry(request.id, request.achReimbursementType, request.transactionAmount, request.pendingTransactionConfirmation, chaseFileDate)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            counts: { ...this.state.counts, pendingPaymentTotal: this.state.counts.pendingPaymentTotal - 1 },
                            list: [...this.state.list].filter(f => f.id != request.id || (f.id == request.id && f.achReimbursementType != reimbursementType))
                        });
                    } else {
                        toast.error('Unable to confirm Reiembursement: ' + response.data.message);
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error('Unable to confirm Reiembursement.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleImportTransactionFile = () => {
        this.setState({
            modal: {
                show: true,
                data: null,
                type: WageAndTravelViewType.ImportTransactionFile
            }
        })
    }

    getOutstandingReimbursementItems = () => {
        const data = this.state.modal.data as IWatrRequest;
        if (!data || !data.requestWeeks) {
            return [];
        }

        const weeks = data.requestWeeks
            .filter(x =>
                x.status == WageAndTravelReimbursementRequestStatus.PendingApproval
                && x.weekRequested > 3)
            .map(x => x.weekRequested);

        if (weeks.length === 0) {
            return [];
        }

        return [{
            name: `${data.firstName} ${data.lastName}`,
            alias: data.donorAlias || data.alias,
            requestId: data.id,
            weeks,
            status: WageAndTravelReimbursementRequestStatus.PendingApproval,
            organType: data.donationOrganType as DashDonationType,
            hasActiveComplicationsReport: data.hasActiveComplicationsReport === true
        }];
    }

    handleUpdateReimbursementStatus = (
        list: IWageAndTravelRequestWeek[],
        physicianLetters?: IPhysicianLetterWeekUpload[],
        _options?: { stayOpen?: boolean }
    ): Promise<void> => {
        return this.props.showLoading('Updating reimbursement status').then(() => {
            return this.props.updateWeekReimbursementRequestStatus(this.props.centerId, list, physicianLetters)
                .then(response => {
                    if (!response.data.success) {
                        toast.error(response.data.message);
                        return Promise.reject(new Error(response.data.message || 'Update failed'));
                    }

                    toast.success(response.data.message);
                    this.setState({
                        modal: { ...this.state.modal, show: false }
                    }, () => {
                        this.getData(this.state.area, this.state.category, true);
                    });
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    getFilteredData = (): IWatrRequest[] => {
        let list = this.state.list.filter(x => {

            let pendingLWRVerify = true;
            let pendingDERVerify = true;
            let pendingLWRPayment = true;
            let pendingDERPayment = true;
            let bothVerifySelected = false;
            let bothPaymentSelected = false;

            if (this.state.subCategory == WageAndTravelCategory.PendVerify && this.state.subGroup.includes(WageAndTravelGroup.LostWage)) {
                pendingLWRVerify = x.pendingLWRVerify;
            }

            if (this.state.subCategory == WageAndTravelCategory.PendVerify && this.state.subGroup.includes(WageAndTravelGroup.DonorExpense)) {
                pendingDERVerify = x.pendingDERVerify;
            }

            if (this.state.subCategory == WageAndTravelCategory.PendingPayment && this.state.subGroup.includes(WageAndTravelGroup.LostWage)) {
                pendingLWRPayment = x.pendingLWRPayment;
            }

            if (this.state.subCategory == WageAndTravelCategory.PendingPayment && this.state.subGroup.includes(WageAndTravelGroup.DonorExpense)) {
                pendingDERPayment = x.pendingDERPayment;
            }

            if (this.state.subCategory == WageAndTravelCategory.PendVerify && this.state.subGroup.includes(WageAndTravelGroup.LostWage) && this.state.subGroup.includes(WageAndTravelGroup.DonorExpense)) {
                bothVerifySelected = true;
            }

            if (this.state.subCategory == WageAndTravelCategory.PendingPayment && this.state.subGroup.includes(WageAndTravelGroup.LostWage) && this.state.subGroup.includes(WageAndTravelGroup.DonorExpense)) {
                bothPaymentSelected = true;
            }

            if (bothVerifySelected) {
                return (pendingLWRVerify || pendingDERVerify)
            }

            if (bothPaymentSelected) {
                return (pendingLWRPayment || pendingDERPayment)
            }

            if (this.state.subGroup.length == 0) {
                return false;
            }

            return (pendingLWRVerify && pendingDERVerify && pendingLWRPayment && pendingDERPayment);
        });

        return list;
    }

    getAdvancedStatusFilteredData = (list: IWatrRequest[]) => {
        if (!isAdvancedDsArea(this.state.area) || this.state.advancedStatusFilter == 'ALL') {
            return list;
        }

        if (this.state.advancedDeepSearchActive) {
            return list;
        }

        return list.filter(x => resolveAdvancedRollupBucket(x) === this.state.advancedStatusFilter);
    }

    applyAdvancedFindFilter = (list: IWatrRequest[]) => {
        if (!isAdvancedDsArea(this.state.area)) {
            return list;
        }

        const find = this.state.advancedFind || EMPTY_ADVANCED_FIND;
        const name = (find.name || '').trim().toLowerCase();
        const alias = (find.alias || '').trim().toLowerCase();
        const email = (find.email || '').trim().toLowerCase();
        const birthDate = (find.birthDate || '').trim();
        const donationDateFrom = (find.donationDateFrom || '').trim();
        const donationDateTo = (find.donationDateTo || '').trim();
        const center = find.center || 0;
        const organType = find.organType;
        const intlDonor = find.intlDonor;

        if (!name && !alias && !email && !birthDate && !donationDateFrom && !donationDateTo
            && center <= 0 && organType < 0 && intlDonor < 0) {
            return list;
        }

        return list.filter((row) => {
            if (name) {
                const rowName = (row.name || '').toLowerCase();
                if (rowName.indexOf(name) < 0) {
                    return false;
                }
            }
            if (alias) {
                const rowAlias = (row.alias || '').toLowerCase();
                if (rowAlias.indexOf(alias) < 0) {
                    return false;
                }
            }
            if (email) {
                const rowEmail = (row.email || '').toLowerCase();
                if (rowEmail.indexOf(email) < 0) {
                    return false;
                }
            }
            if (organType >= 0 && row.donationOrganType !== organType) {
                return false;
            }
            if (intlDonor >= 0) {
                const isIntl = readIsInternationallyEligibleForWatr(row);
                if (intlDonor === 1 && !isIntl) {
                    return false;
                }
                if (intlDonor === 0 && isIntl) {
                    return false;
                }
            }
            if (birthDate) {
                const rowBirth = moment(row.birthDate);
                const findBirth = moment(birthDate, 'YYYY-MM-DD', true);
                if (!rowBirth.isValid() || !findBirth.isValid() || !rowBirth.isSame(findBirth, 'day')) {
                    return false;
                }
            }
            if (donationDateFrom || donationDateTo) {
                const rowDonation = moment(row.donationDate);
                if (!rowDonation.isValid()) {
                    return false;
                }
                if (donationDateFrom) {
                    const from = moment(donationDateFrom, 'YYYY-MM-DD', true).startOf('day');
                    if (from.isValid() && rowDonation.isBefore(from)) {
                        return false;
                    }
                }
                if (donationDateTo) {
                    const to = moment(donationDateTo, 'YYYY-MM-DD', true).endOf('day');
                    if (to.isValid() && rowDonation.isAfter(to)) {
                        return false;
                    }
                }
            }
            if (center > 0 && row.centerId !== center) {
                return false;
            }
            return true;
        });
    }

    getAdvancedDisplayList = (list: IWatrRequest[]) => {
        if (!isAdvancedDsArea(this.state.area)) {
            return list;
        }
        const source = this.state.advancedDeepSearchActive
            ? (this.state.advancedDeepSearchResults || [])
            : list;
        return this.applyAdvancedFindFilter(this.getAdvancedStatusFilteredData(source));
    }

    getAdvancedFindChips = (): AdvancedFindChip[] => {
        const chips: AdvancedFindChip[] = [];
        if (!isAdvancedDsArea(this.state.area)) {
            return chips;
        }

        if (this.state.advancedDeepSearchActive) {
            chips.push({ key: 'deep', label: 'Search results' });
        }

        if (this.state.advancedStatusFilter === 'TODO_NKR') {
            return chips.filter(c => c.key === 'deep');
        }

        const find = this.state.advancedFind || EMPTY_ADVANCED_FIND;
        if ((find.name || '').trim()) {
            chips.push({ key: 'name', label: `Name: ${find.name.trim()}` });
        }
        if ((find.alias || '').trim()) {
            chips.push({ key: 'alias', label: `Alias: ${find.alias.trim()}` });
        }
        if ((find.email || '').trim()) {
            chips.push({ key: 'email', label: `Email: ${find.email.trim()}` });
        }
        if (find.organType === OrganType.Kidney) {
            chips.push({ key: 'organType', label: 'Organ: Kidney' });
        } else if (find.organType === OrganType.Liver) {
            chips.push({ key: 'organType', label: 'Organ: Liver' });
        }
        if (find.intlDonor === 1) {
            chips.push({ key: 'intlDonor', label: 'Intl: Yes' });
        } else if (find.intlDonor === 0) {
            chips.push({ key: 'intlDonor', label: 'Intl: No' });
        }
        if ((find.donationDateFrom || '').trim()) {
            chips.push({ key: 'donationDateFrom', label: `Donation from: ${find.donationDateFrom.trim()}` });
        }
        if ((find.donationDateTo || '').trim()) {
            chips.push({ key: 'donationDateTo', label: `Donation to: ${find.donationDateTo.trim()}` });
        }
        if ((find.birthDate || '').trim()) {
            chips.push({ key: 'birthDate', label: `DOB: ${find.birthDate.trim()}` });
        }
        if (find.center > 0) {
            const center = (this.state.centerList || []).find(c => c.id === find.center);
            chips.push({ key: 'center', label: `Center: ${center ? center.alias : find.center}` });
        }

        return chips;
    }

    replaceArTabQueryInBrowserUrl = (tab: AdvancedRollupFilterValue) => {
        const parsed = qs.parse(window.location.search.length > 0 ? window.location.search : '', { arrayFormat: 'bracket' });
        parsed[AR_TAB_QUERY_KEY] = arTabQueryValueForFilter(tab);
        const newSearch = qs.stringify(parsed);
        const url = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}${window.location.hash || ''}`;
        window.history.replaceState(null, '', url);
    }

    handleAdvancedStatusFilterChange = (value: AdvancedRollupFilterValue) => {
        if (value === 'SEARCH') {
            this.handleToggleAdvancedDeepSearch(true);
            return;
        }

        const current = this._pendingAdvancedFilter != null
            ? this._pendingAdvancedFilter
            : this.state.advancedStatusFilter;
        if (value === current
            && !this.state.advancedDeepSearchActive
            && !this.state.advancedDeepSearchOpen
            && !this.state.fetching) {
            return;
        }

        this.scheduleSoftAdvancedStatusLoad(value);
    }

    handleAdvancedFindChange = (property: keyof AdvancedFindFields, value: string | number) => {
        this.setState({
            advancedFind: {
                ...this.state.advancedFind,
                [property]: value,
            },
        });
    }

    handleClearAdvancedFindField = (key: string) => {
        if (key === 'deep') {
            this.handleExitAdvancedDeepSearch();
            return;
        }
        if (key === 'name' || key === 'alias' || key === 'email' || key === 'birthDate'
            || key === 'donationDateFrom' || key === 'donationDateTo') {
            this.setState({
                advancedFind: {
                    ...this.state.advancedFind,
                    [key]: '',
                },
            });
            return;
        }
        if (key === 'center') {
            this.setState({
                advancedFind: {
                    ...this.state.advancedFind,
                    center: 0,
                },
            });
            return;
        }
        if (key === 'organType') {
            this.setState({
                advancedFind: {
                    ...this.state.advancedFind,
                    organType: -1,
                },
            });
            return;
        }
        if (key === 'intlDonor') {
            this.setState({
                advancedFind: {
                    ...this.state.advancedFind,
                    intlDonor: -1,
                },
            });
        }
    }

    handleClearAllAdvancedFind = () => {
        this.setState({
            advancedFind: { ...EMPTY_ADVANCED_FIND },
        });
    }

    handleToggleAdvancedDeepSearch = (forceOpen?: boolean) => {
        const open = forceOpen === true ? true : !this.state.advancedDeepSearchOpen;
        if (open) {
            this.replaceArTabQueryInBrowserUrl('SEARCH');
            this.setState({
                advancedDeepSearchOpen: true,
                advancedStatusBeforeDeepSearch: this.state.advancedDeepSearchActive
                    ? this.state.advancedStatusBeforeDeepSearch
                    : this.state.advancedStatusFilter,
                search: {
                    ...this.state.search,
                    area: DsArea.Advanced,
                    category: 0,
                },
            });
            return;
        }

        if (this.state.advancedDeepSearchActive) {
            this.handleExitAdvancedDeepSearch();
            return;
        }

        const restore = this.state.advancedStatusBeforeDeepSearch || 'ALL';
        this.replaceArTabQueryInBrowserUrl(restore);
        this.setState({ advancedDeepSearchOpen: false });
    }

    handleExitAdvancedDeepSearch = () => {
        const restore = this.state.advancedStatusBeforeDeepSearch || 'ALL';
        this.scheduleSoftAdvancedStatusLoad(restore);
    }

    handleAdvancedDeepSearch = () => {
        let { firstName, lastName, email, birthDate, alias, center, area, startDate, endDate, category } = this.state.search;
        let centerId = this.props.centerId > 0 ? this.props.centerId : center;
        const organType = this.resolveFetchOrganType(WageAndTravelCategory.Search);

        this.props.showLoading('Looking for requests, one moment please...').then(() => {
            this.props.searchRequests(centerId, firstName, lastName, email, birthDate, alias, startDate, endDate, DsArea.Advanced, 0, this.props.isSuperUser, organType)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            advancedDeepSearchActive: true,
                            advancedDeepSearchOpen: true,
                            advancedDeepSearchResults: response.data.results || [],
                            organType,
                            search: {
                                ...this.state.search,
                                area: DsArea.Advanced,
                                category: 0,
                            },
                        }, () => {
                            this.setUrlParameters();
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleAdvancedDeepReset = () => {
        let startDate = moment().subtract(60, 'days').format('YYYY-MM-DD');
        let endDate = moment().format('YYYY-MM-DD');
        this.setState({
            search: {
                firstName: '',
                lastName: '',
                email: '',
                birthDate: '',
                alias: '',
                center: 0,
                area: DsArea.Advanced,
                category: 0,
                startDate,
                endDate,
            },
        });
    }

    getAdvancedStatusFilterCount = (filterValue: AdvancedRollupFilterValue) => {
        if (filterValue === 'SEARCH') {
            return null;
        }
        let list = this.state.advancedSourceList != null && this.state.advancedSourceList.length > 0
            ? this.state.advancedSourceList
            : this.state.list;
        if (list == null || list.length == 0) {
            return 0;
        }
        if (filterValue == 'ALL') {
            return list.length;
        }
        return list.filter(x => resolveAdvancedRollupBucket(x) === filterValue).length;
    }

    getGridHeight = () => {
        let isCenterView = this.props.centerId > 0 ? true : false;
        const isSearchView = this.state.category == WageAndTravelCategory.Search
            || (isAdvancedDsArea(this.state.area) && this.state.advancedDeepSearchOpen);
        let gridHeight = !isSearchView ? '70vh' : '64vh';

        if (isCenterView) {
            gridHeight = '62vh';
        }

        if (isSearchView) {
            gridHeight = '54vh';
        }

        return gridHeight;
    }

    handleApprovalEmail = (requestId: number, emailSubject: string, firstParagraph: string, emailContent: string) => {
        let { approvalEmailType, approvalData, modal: { data } } = this.state;

        let email: ApprovalEmailContract = {
            emailType: this.state.approvalEmailType,
            requestId: requestId,
            emailSubject: emailSubject,
            firstParagraph: firstParagraph,
            emailContent: emailContent
        }

        if (approvalEmailType == ApprovalEmailType.VerifyTax) {
            this.sendVerifyTax(approvalData, email)
        }

        if (approvalEmailType == ApprovalEmailType.VerifyPayStub) {
            this.sendVerifyStub(approvalData, email)
        }

        if (approvalEmailType == ApprovalEmailType.VerifyAmount) {
            this.sendVerifyAmount(approvalData, email)
        }

        if (approvalEmailType == ApprovalEmailType.VerifyExpense) {
            //have to map to Request Id and not Travel Request Id
            email.requestId = data.id
            this.sendVerifyTravel(approvalData, email)
        }
    }

    applyWeekOtherAmountLocally = (requestId: number, weekRequested: number, otherAmount: number) => {
        this.setState(prev => {
            const data = prev.view && prev.view.data;

            if (!data || data.id !== requestId || !data.requestWeeks) {
                return null;
            }

            return {
                view: {
                    ...prev.view,
                    data: {
                        ...data,
                        requestWeeks: data.requestWeeks.map(w =>
                            w.weekRequested === weekRequested ? { ...w, otherAmount } : w
                        )
                    }
                }
            };
        });
    }

    handleUpdateRequestWeekOtherAmount = (requestId: number, weekRequested: number, otherAmount: number, confirmedByInitials?: string) => {
        return this.props.updateWeekOtherAmount(requestId, weekRequested, otherAmount, confirmedByInitials)
            .then(response => {
                if (response?.data?.success) {
                    toast.success('Other Amount saved.');
                    this.applyWeekOtherAmountLocally(requestId, weekRequested, otherAmount);
                }
                return response;
            });
    }

    render = () => {
        const contextValue: IDonorShieldContext = {
            isNkrSuper: this.props.isSuperUser,
            currentUser: this.props.app.user,
            auditLogTypes: this.state.auditLogTypes,
            logActionTypes: this.state.logActionTypes,
            donationTypes: this.state.donationTypes,
            reimbursementTypes: this.state.reimbursementTypes,
            statusTypes: this.state.statusTypes,
            requestTypes: this.state.requestTypes,
            onShowDataSideBar: this.showAdditionalInfoSidebar,
            onHideDataSideBar: this.handleCancelAdditionalInfoSidebar,
            onCloseRequestView: this.handleCancelView,
            onRefreshList: () => this.refreshActiveList(),
            fetchFileUrl: this.fetchFileUrl,
            downloadFile: this.props.downloadFile,
            onRefreshRequest: () => {
                if (this.state.view && this.state.view.show && this.state.view.data && this.state.view.data.id) {
                    this.getRequestData(this.state.view.data.id, this.state.view.type);
                }
            },
            handleSaveLogEntry: this.handleSaveLogEntry,
            handleUpdateLogEntry: this.handleUpdateLogEntry,
            handleDeleteLogEntry: this.handleDeleteLogEntry,
            onReimbursementEntry: this.handleReimbursementEntry,
            onReimbursementUpdate: this.handleReimbursementUpdate,
            onVerifyTravel: this.handleVerifyTravel,
            onVerifyTax: this.handleVerifyTax,
            onVerifyPayStub: this.handleVerifyStub,
            onVerifyAmount: this.handleVerifyAmount,
            showLoading: this.props.showLoading,
            hideLoading: this.props.hideLoading,
            onShowDeclineModal: this.showDeclineModal,
            onUpdateTitle: null,
            onUpdateRequestWeekOtherAmount: this.handleUpdateRequestWeekOtherAmount,
            onUpdateRequestBanking: this.handleUpdateRequestBanking,
            onSetReviewRequiredBulk: async (lineItemIds: number[], reviewRequired: boolean) => {
                return Promise.resolve();
            },
            onSetPaystubReviewRequired: async (paystubId: number, reviewRequired: boolean) => {
                await this.props.setPaystubReviewRequired(paystubId, reviewRequired);
            }
        };

        const selectedModalViewType = this.state.modal.type;
        const showSearch = this.state.category == WageAndTravelCategory.Search
            || (this.state.category == WageAndTravelCategory.PendSurgery && this.props.isSuperUser);
        const showToDoSearch = (this.state.category == WageAndTravelCategory.ToDo || this.state.category == WageAndTravelCategory.PendDocs) && this.props.centerId == 0;;
        const total = this.getTotal();

        const filteredData = this.getAdvancedDisplayList(this.state.list);
        const needsTotals = showToDoSearch || isAdvancedDsArea(this.state.area);
        const wageTotal = needsTotals ? filteredData.reduce((total, item) => total + item.lwr, 0) : 0;
        const expensesTotal = needsTotals ? filteredData.reduce((total, item) => total + item.tlr, 0) : 0;
        const gridHeight = this.getGridHeight();
        const advancedFindChips = this.getAdvancedFindChips();

        return (
            <>
                <DonorShieldProvider value={contextValue}>
                    <MediaQuery minWidth={1023} style={{ padding: 0 }}>
                        <WatrListShell className={[
                            this.state.additionalInfoSidebar.show ? 'is-viewer-open' : '',
                            this.state.view.show ? 'is-request-open' : ''
                        ].filter(Boolean).join(' ') || undefined}>
                        <div ref={this.saveContainer}></div>
                        {this.state.view.data && this.state.additionalInfoSidebar.show && (
                            <div className='watr-document-viewer-slot'>
                                <AdditionalInfoSidebar
                                    data={this.state.view.data}
                                    centerId={this.props.centerId}
                                    show={this.state.additionalInfoSidebar.show}
                                    displayType={this.state.additionalInfoSidebar.displayType}
                                    fileUrl={this.state.additionalInfoSidebar.fileUrl}
                                    fileIds={this.state.additionalInfoSidebar.fileIds}
                                    currentFileIndex={this.state.additionalInfoSidebar.currentIndex}
                                    totalFiles={this.state.additionalInfoSidebar.totalFiles}
                                    fileIdToLineItemsMap={this.state.additionalInfoSidebar.fileIdToLineItemsMap}
                                    fetchFileUrl={this.fetchFileUrl}
                                    onApproveLineItems={this.state.additionalInfoSidebar.onApproveLineItems}
                                    onRequestReviewLineItems={this.state.additionalInfoSidebar.onRequestReviewLineItems}
                                    onExpenseTypeChange={this.state.additionalInfoSidebar.onExpenseTypeChange}
                                    onExpenseTypeApproved={this.state.additionalInfoSidebar.onExpenseTypeApproved}
                                    onRefreshLineItems={this.state.additionalInfoSidebar.onRefreshLineItems}
                                    onReviewRequiredStateChange={this.state.additionalInfoSidebar.onReviewRequiredStateChange}
                                    viewerDocs={this.state.additionalInfoSidebar.viewerDocs}
                                    onViewerDocChange={this.state.additionalInfoSidebar.onViewerDocChange}
                                    onCancelView={this.handleCancelAdditionalInfoSidebar}
                                    inline={true}
                                />
                            </div>
                        )}
                        <div className='watr-list-main'>

                        {this.state.category != WageAndTravelCategory.AddRequest && (
                            <Filters
                                isNkrAdmin={this.props.isSuperUser}
                                centerId={this.props.centerId}
                                area={this.state.area}
                                activeTab={this.state.category}
                                counts={this.state.counts}
                                organTypes={this.state.organTypes}
                                isLoading={this.state.fetching}
                                onExport={this.handlePageExport}
                                onChangeOrganType={this.handleChangeOrganType}
                                canConfirmAll={this.state.list.some(f => f.pendingTransactionConfirmation)}
                                onConfirmAll={this.handleConfirmAll}
                                onChaseExport={this.handleChaseExport}
                                onValidateRouting={this.handleVerifyRoutingNumbers}
                                onImportTransactionFile={this.handleImportTransactionFile}
                                onReportTabChange={this.handleReportTabChange}
                                onStandardCategoryChange={this.handleStandardCategoryChange}
                            />
                        )}

                        {this.state.category != WageAndTravelCategory.YearEndReport
                            && this.state.category != WageAndTravelCategory.Transactions
                            && this.state.category != WageAndTravelCategory.AddRequest
                            && this.state.category != WageAndTravelCategory.PendRegistration
                            && (
                                <>
                                    {showToDoSearch && this.props.isSuperUser && (
                                        <SubFilterBar
                                            filterGroup={this.state.subGroup}
                                            filterCategory={this.state.subCategory}
                                            filterStartDate={this.state.search.startDate}
                                            filterEndDate={this.state.search.endDate}
                                            isNkrAdmin={this.props.isSuperUser}
                                            counts={this.state.counts}
                                            wageTotal={wageTotal}
                                            expensesTotal={expensesTotal}
                                            category={this.state.category}
                                            displayedCount={filteredData.length}
                                            totalCount={this.state.counts != null ? this.state.counts.pendingDocumentsTotal : 0}
                                            onChaseExport={this.handleChaseExport}
                                            onUpdateCategory={this.handleUpdateCategory}
                                            onUpdateGroup={this.handleUpdateGroup}
                                            onUpdateDate={this.handleUpdateDate}
                                            onDateSearch={this.handleDateSearch}
                                        />
                                    )}

                                    {isAdvancedDsArea(this.state.area) && (
                                        <div style={{ marginBottom: 16 }}>
                                            <WatrNavWrapper fontSize='15px'>
                                                <div className='watr-nav-shell watr-nav-shell--continuation' style={{ minWidth: 0 }}>
                                                    <ul className='nav nav-pills ms-pills ms-child-tabs' role='navigation' aria-label='Advanced reimbursement status'>
                                                        {getAdvancedRollupFilterPillOrder().map((b, index, arr) => {
                                                            const opt = { id: b as AdvancedRollupFilterValue, label: advancedRollupTabLabel(b, this.props.isSuperUser) };
                                                            const searchMode = this.state.advancedDeepSearchOpen || this.state.advancedDeepSearchActive;
                                                            let active = (opt.id === 'SEARCH' && searchMode)
                                                                || (!searchMode && this.state.advancedStatusFilter == opt.id);
                                                            let n = opt.id === 'SEARCH' ? null : this.getAdvancedStatusFilterCount(opt.id);
                                                            const countLabel = n === null ? (opt.id === 'SEARCH' ? '' : '-') : String(n);
                                                            const pillText = opt.id === 'SEARCH'
                                                                ? opt.label
                                                                : `${opt.label} (${countLabel})`;
                                                            return (
                                                                <React.Fragment key={opt.id}>
                                                                    <WatrNavItemWrapper
                                                                        active={active}
                                                                        href='#'
                                                                        aria-current={active ? 'page' : undefined}
                                                                        onClick={(e: React.MouseEvent<HTMLElement>) => {
                                                                            e.preventDefault();
                                                                            this.handleAdvancedStatusFilterChange(opt.id);
                                                                        }}
                                                                    >
                                                                        {pillText}
                                                                    </WatrNavItemWrapper>
                                                                    {index < arr.length - 1 && (
                                                                        <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>
                                                                    )}
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </ul>
                                                </div>
                                            </WatrNavWrapper>
                                            {(this.state.advancedDeepSearchOpen || this.state.advancedDeepSearchActive) && (
                                                <AdvancedFindBar
                                                    mode="systemSearch"
                                                    find={this.state.advancedFind}
                                                    isAdmin={this.props.isSuperUser}
                                                    centerList={this.state.centerList}
                                                    deepSearchActive={this.state.advancedDeepSearchActive}
                                                    chips={advancedFindChips.filter(c => c.key === 'deep')}
                                                    deepFirstName={this.state.search.firstName}
                                                    deepLastName={this.state.search.lastName}
                                                    deepEmail={this.state.search.email}
                                                    deepBirthDate={this.state.search.birthDate}
                                                    deepAlias={this.state.search.alias}
                                                    deepCenter={this.state.search.center}
                                                    deepStartDate={this.state.search.startDate}
                                                    deepEndDate={this.state.search.endDate}
                                                    onFindChange={this.handleAdvancedFindChange}
                                                    onClearFindField={this.handleClearAdvancedFindField}
                                                    onClearAllFind={this.handleClearAllAdvancedFind}
                                                    onExitDeepSearch={this.handleExitAdvancedDeepSearch}
                                                    onDeepFieldChange={this.handleUpdateSearch}
                                                    onDeepSearch={this.handleAdvancedDeepSearch}
                                                    onDeepReset={this.handleAdvancedDeepReset}
                                                />
                                            )}
                                            {!this.state.advancedDeepSearchOpen
                                                && !this.state.advancedDeepSearchActive
                                                && this.state.advancedStatusFilter !== 'TODO_NKR'
                                                && (
                                                <AdvancedFindBar
                                                    mode="subset"
                                                    find={this.state.advancedFind}
                                                    isAdmin={this.props.isSuperUser}
                                                    centerList={this.state.centerList}
                                                    deepSearchActive={false}
                                                    chips={advancedFindChips.filter(c => c.key !== 'deep')}
                                                    deepFirstName={this.state.search.firstName}
                                                    deepLastName={this.state.search.lastName}
                                                    deepEmail={this.state.search.email}
                                                    deepBirthDate={this.state.search.birthDate}
                                                    deepAlias={this.state.search.alias}
                                                    deepCenter={this.state.search.center}
                                                    deepStartDate={this.state.search.startDate}
                                                    deepEndDate={this.state.search.endDate}
                                                    onFindChange={this.handleAdvancedFindChange}
                                                    onClearFindField={this.handleClearAdvancedFindField}
                                                    onClearAllFind={this.handleClearAllAdvancedFind}
                                                    onExitDeepSearch={this.handleExitAdvancedDeepSearch}
                                                    onDeepFieldChange={this.handleUpdateSearch}
                                                    onDeepSearch={this.handleAdvancedDeepSearch}
                                                    onDeepReset={this.handleAdvancedDeepReset}
                                                />
                                            )}
                                        </div>
                                    )}

                                    {showSearch && (
                                        <SearchBar
                                            firstName={this.state.search.firstName}
                                            lastName={this.state.search.lastName}
                                            email={this.state.search.email}
                                            birthDate={this.state.search.birthDate}
                                            alias={this.state.search.alias}
                                            center={this.state.search.center}
                                            category={this.state.search.category}
                                            startDate={this.state.search.startDate}
                                            endDate={this.state.search.endDate}
                                            isAdmin={this.props.isSuperUser}
                                            centerList={this.state.centerList}
                                            categoryList={this.state.categoryList}
                                            onUpdate={this.handleUpdateSearch}
                                            onSearch={this.handleSearch}
                                            onReset={this.handleResetSearch}
                                        />
                                    )}

                                    <WatrAgGrid
                                        list={filteredData}
                                        gridApi={this.gridApi}
                                        columnApi={this.columnApi}
                                        area={this.state.area}
                                        selectedTab={this.state.category}
                                        isSearchView={this.state.category == WageAndTravelCategory.Search
                                            || this.state.advancedDeepSearchOpen
                                            || this.state.advancedDeepSearchActive}
                                        height={gridHeight}
                                        isCenterView={this.props.centerId > 0}
                                        isLoading={this.state.fetching}
                                        onActionRequest={this.handleActionRequest}
                                        resendInvitation={this.handleResendInvite}
                                        onAdvancedWorkflowAction={this.handleAdvancedWorkflowAction}
                                        onReconcileTransactions={this.handleReconcileTransactions}
                                        onSetGridComponents={this.onGridReady}
                                    />
                                </>
                            )}

                        {this.state.category == WageAndTravelCategory.YearEndReport && (
                            <YearEndReport
                                gridApi={this.gridApiYearEnd}
                                columnApi={this.columnApiYearEnd}
                                organTypes={this.state.organTypes}
                                onChangeOrganType={this.handleChangeOrganType}
                                onSetGridComponents={this.onYearEndGridReady}
                                onUpdateSidebarView={this.handleAuditYearEnd}
                            />
                        )}

                        {this.state.category == WageAndTravelCategory.Transactions && (
                            <Transactions
                                gridApi={this.gridApiTransactions}
                                columnApi={this.columnApiTransactions}
                                onGridReady={this.onTransactionsGridReady}
                                organTypes={this.state.organTypes}
                                onChangeOrganType={this.handleChangeOrganType}
                            />
                        )}

                        {this.state.category == WageAndTravelCategory.AddRequest && (
                            <AddRequest
                                centerId={this.props.centerId}
                                isSuperUser={this.props.isSuperUser}
                            />
                        )}

                        {this.state.category == WageAndTravelCategory.PendRegistration && (
                            <PendingRegistrationList
                                centerId={this.props.centerId}
                                organTypes={this.state.organTypes}
                                onGridReady={this.onPendingRegistrationGridReady}
                            />
                        )}

                        <Sidebar
                            data={this.state.view.data}
                            type={this.state.view.type}
                            reimbursements={this.state.view.reimbursements}
                            category={this.state.category}
                            show={this.state.view.show}
                            validation={this.state.validation}
                            isDirty={this.state.isDirty}
                            openReconcileReimbursementEntry={this.state.view.openReconcileReimbursementEntry}
                            countryList={this.state.countryList}
                            getContainer={this.getContainer}
                            onUpdateDonorRequest={this.handleUpdateDonorRequest}
                            onCancelView={this.handleCancelView}
                            updateAudit={this.handleAuditUpdate}
                        />

                        </div>
                        </WatrListShell>
                    </MediaQuery>

                    <Decline
                        show={this.state.modal.show && selectedModalViewType == WageAndTravelViewType.DeclineRequest}
                        data={this.state.modal.data}
                        declineType={this.state.declineType}
                        allowWageSelection={this.state.category !== WageAndTravelCategory.PaymentError}
                        onDeclineRequest={this.handleDeclineRequest}
                        onClose={this.handleClose}
                        hasLineItemsSelected={this.state.declineType == 'Expense' ? this.state.hasLineItemsSelected : undefined}
                        claimDeclineResponseList={this.state.claimDeclineResponseList}
                    />

                    <ApprovalEmail
                        show={this.state.modal.show && selectedModalViewType == WageAndTravelViewType.ApprovalEmail}
                        data={this.state.modal.data}
                        approvalEmailType={this.state.approvalEmailType}
                        onApproval={this.handleApprovalEmail}
                        onClose={this.handleClose}
                    />

                    <CancelRequest
                        show={this.state.modal.show && selectedModalViewType == WageAndTravelViewType.CancelRequest}
                        data={this.state.modal.data}
                        onCancelRequest={this.handleCancelRequest}
                        onClose={this.handleClose}
                    />

                    <ConfirmDonation
                        show={this.state.modal.show && selectedModalViewType == WageAndTravelViewType.ConfirmDonation}
                        data={this.state.modal.data}
                        onConfirmDonation={this.handleConfirmDonation}
                        onUpdateDonationDate={this.handleUpdateDonationDate}
                        onClose={this.handleClose}
                    />

                    <RequestAdditional
                        show={this.state.modal.show && selectedModalViewType == WageAndTravelViewType.AdditionalDays}
                        types={this.state.reimbursementTypes}
                        reimbursements={this.state.view.reimbursements}
                        data={this.state.modal.data}
                        onRequestAdditionalDays={this.handleRequestAdditionalDays}
                        onCancel={this.handleClose}
                    />

                    <OutstandingReimbursementRequests
                        centerId={this.props.centerId}
                        show={this.state.modal.show && selectedModalViewType == WageAndTravelViewType.ApproveWeekReimbursements}
                        items={selectedModalViewType == WageAndTravelViewType.ApproveWeekReimbursements
                            ? this.getOutstandingReimbursementItems()
                            : []}
                        startInReview={true}
                        onSave={this.handleUpdateReimbursementStatus}
                        onClose={this.handleClose}
                    />

                    <PaymentError
                        show={this.state.modal.show && selectedModalViewType == WageAndTravelViewType.PaymentError}
                        data={this.state.modal.data}
                        onPaymentErrorUpdate={this.handlePaymentErrorUpdate}
                        onClose={this.handleClose}
                    />

                    <ChaseTransactionUpload
                        show={this.state.modal.show && selectedModalViewType == WageAndTravelViewType.ImportTransactionFile}
                        onOnFileUpload={this.handleChaseTransactionUpload}
                        data={this.state.modal.data}
                        onClose={this.handleClose}
                    />

                    <ValidateBankInfo
                        show={this.state.modal.show && selectedModalViewType == WageAndTravelViewType.ValidateBankInfo}
                        data={this.state.modal.data}
                        onClose={this.handleClose}
                    />
                </DonorShieldProvider>
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getRequestList: (centerId, area, category, startDate, endDate, isSuperUser, organType) => {
            if (category == WageAndTravelCategory.PendingPayment) {
                return dispatch(WatrActionCreators.getAchPayments(organType));
            } else {
                return dispatch(WatrActionCreators.getRequestList(centerId, area, category, startDate, endDate, isSuperUser, organType));
            }

        },
        searchRequests: (centerId, firstName, lastName, email, birthDate, alias, startDate, endDate, area, category, isAdmin, organType) => {
            return dispatch(WatrActionCreators.searchRequests(centerId, firstName, lastName, email, birthDate, alias, startDate, endDate, area, category, isAdmin, organType));
        },
        getRequestCounts: (centerId, area, category, startDate, endDate, isAdmin, organType) => {
            return dispatch(WatrActionCreators.getRequestCounts(centerId, area, category, startDate, endDate, isAdmin, organType));
        },
        getTravelDetails: (centerId, requestId, isAdmin) => {
            return dispatch(WatrActionCreators.getTravelDetails(centerId, requestId, isAdmin));
        },
        getReimbursementsByRequestId: (requestId) => {
            return dispatch(WatrActionCreators.getReimbursementsByRequestId(requestId));
        },
        getRequestById: (centerId, requestId) => {
            return dispatch(WatrActionCreators.getRequestById(centerId, requestId));
        },
        getLogsByRequestId: (requestId) => {
            return dispatch(WatrActionCreators.getLogsByRequestId(requestId));
        },
        getRequestLookupData: () => {
            return dispatch(WatrActionCreators.getLookupData());
        },
        updateDonorRequest: (request) => {
            return dispatch(WatrActionCreators.updateDonorRequest(request));
        },
        saveReimbursementEntry: (requestId, type, amount, confirmationCode, date, closeAdvancedReimbursementCard) => {
            return dispatch(WatrActionCreators.createReimbursement(requestId, type, amount, confirmationCode, date, closeAdvancedReimbursementCard));
        },
        confirmReimbursements: (items) => {
            return dispatch(WatrActionCreators.confirmReimbursements(items));
        },
        updateReimbursement: (requestId, reimbursementId, type, amount, confirmationCode, date) => {
            return dispatch(WatrActionCreators.updateReimbursement(requestId, reimbursementId, type, amount, confirmationCode, date));
        },
        saveLogEntry: (requestId, type, comments, file) => {
            return dispatch(WatrActionCreators.createAuditLog(requestId, type, comments, file));
        },
        updateLogEntry: (requestId, logId, type, comments, file) => {
            return dispatch(WatrActionCreators.updateAuditLog(requestId, logId, type, comments, file));
        },
        deleteLogEntry: (requestId, logId) => {
            return dispatch(WatrActionCreators.deleteAuditLog(requestId, logId));
        },
        verifyAmount: (requestId, status, sendEmail, amount, approvalEmail) => {
            return dispatch(WatrActionCreators.verifyAmount(requestId, status, sendEmail, amount, approvalEmail));
        },
        verifyStub: (requestId, startDate, endDate, grossAmount, paystubs, approvalEmail, ssnDecrypted, incomeIrsYear, incomeIrsYearGross) => {
            return dispatch(WatrActionCreators.verifyStub(requestId, startDate, endDate, grossAmount, paystubs, approvalEmail, ssnDecrypted, incomeIrsYear, incomeIrsYearGross) as any);
        },
        setPaystubReviewRequired: (paystubId, reviewRequired) => {
            return dispatch(WatrActionCreators.setPaystubReviewRequired(paystubId, reviewRequired));
        },
        verifyTax: (requestId, ssnEncrypted, irsYear, irsYearGross, approvalEmail) => {
            return dispatch(WatrActionCreators.verifyTax(requestId, ssnEncrypted, irsYear, irsYearGross, approvalEmail));
        },
        verifyTravel: (travelRequestId, roundTripMiles, hotelLodgingExpense, flightAndTrainExpense, carServiceExpense, dependentCareExpense,
            mealExpense, isMilesOverWritten, overrideMiles, isMealsOverWritten, overrideMeals,
            isCarServiceExpenseOverridden, overrideCarServiceExpense,
            isDependentCareExpenseOverridden, overrideDependentCareExpense,
            isHotelLodgingExpenseOverridden, overrideHotelLodgingExpense,
            approvalEmail
        ) => {
            return dispatch(WatrActionCreators.verifyTravel(travelRequestId, roundTripMiles, hotelLodgingExpense, flightAndTrainExpense, carServiceExpense, dependentCareExpense,
                mealExpense, isMilesOverWritten, overrideMiles, isMealsOverWritten, overrideMeals,
                isCarServiceExpenseOverridden, overrideCarServiceExpense,
                isDependentCareExpenseOverridden, overrideDependentCareExpense,
                isHotelLodgingExpenseOverridden, overrideHotelLodgingExpense,
                approvalEmail
            ));
        },
        requestAdditionalDays: (requestId, additionalDays, additionalDaysSignOff, drFullNameSignOff) => {
            return dispatch(WatrActionCreators.requestAdditionalDays(requestId, additionalDays, additionalDaysSignOff, drFullNameSignOff));
        },
        declineRequest: (requestId, emailSubject, firstParagraph, emailContent, lastParagraph, isTravel, isFixable, bccCenter, wageRepairRequested, bankingRoutingRequiresReview, bankingAccountRequiresReview, declineReasonSummary) => {
            return dispatch(WatrActionCreators.declineRequest(requestId, emailSubject, firstParagraph, emailContent, lastParagraph, isTravel, isFixable, bccCenter, wageRepairRequested, bankingRoutingRequiresReview, bankingAccountRequiresReview, declineReasonSummary));
        },
        cancelRequest: (requestId) => {
            return dispatch(WatrActionCreators.cancelRequest(requestId));
        },
        confirmDonation: (requestId, signOffInitials) => {
            return dispatch(WatrActionCreators.confirmDonation(requestId, signOffInitials));
        },
        updateDonationDate: (requestId, donationDate) => {
            return dispatch(WatrActionCreators.updateDonationDate(requestId, donationDate));
        },
        updateAudit: (requestId, type, status, reimbursementAmount, donationDate, incomePercentCovered, sixtyDayOverride, ninetyDayLWROverride, expenseLimitOverride) => {
            return dispatch(WatrActionCreators.updateAudit(requestId, type, status, reimbursementAmount, donationDate, incomePercentCovered, sixtyDayOverride, ninetyDayLWROverride, expenseLimitOverride));
        },
        downloadFile: (docType, lookupId) => {
            return dispatch(FileActionCreators.downloadFile(docType, lookupId));
        },
        resendInvitation: (requestId,) => {
            return dispatch(WatrActionCreators.resendInvitation(requestId));
        },
        approveAdvancedReimbursement: (requestId, reason) => {
            return dispatch(WatrActionCreators.approveAdvancedReimbursement(requestId, reason));
        },
        denyAdvancedReimbursement: (requestId, reason) => {
            return dispatch(WatrActionCreators.denyAdvancedReimbursement(requestId, reason));
        },
        holdAdvancedReimbursement: (requestId, reason) => {
            return dispatch(WatrActionCreators.holdAdvancedReimbursement(requestId, reason));
        },
        releaseAdvancedReimbursement: (requestId, reason) => {
            return dispatch(WatrActionCreators.releaseAdvancedReimbursement(requestId, reason));
        },
        activateAdvancedReimbursement: (requestId, reason) => {
            return dispatch(WatrActionCreators.activateAdvancedReimbursement(requestId, reason));
        },
        updateWeekReimbursementRequestStatus: (centerId, list, physicianLetters) => {
            return dispatch(ActionCenterActionCreators.updateWeekReimbursementRequestStatus(centerId, list, physicianLetters))
        },
        updateWeekOtherAmount: (requestId, weekRequested, otherAmount, confirmedByInitials) => {
            return dispatch(WatrActionCreators.updateWeekOtherAmount(requestId, weekRequested, otherAmount, confirmedByInitials))
        },
        getChaseListExport: (organType: OrganType) => {
            return dispatch(WatrActionCreators.getChaseExport(organType));
        },
        updatePaymentError: (paymentError: IWatrPaymentError) => {
            return dispatch(WatrActionCreators.updatePaymentError(paymentError));
        },
        getAchPayments: (organType: OrganType) => {
            return dispatch(WatrActionCreators.getAchPayments(organType));
        },
        validateAchRouting: () => {
            return dispatch(WatrActionCreators.validateAchRouting());
        },
        uploadChaseTransactions: (file: File) => {
            return dispatch(WatrActionCreators.uploadChaseTransactions(file));
        }

    }
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(WageAndTravel);